import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { withStyles } from '@material-ui/core/styles';

export const WSGIcon = ({ ...props }) => (
  <svg viewBox="0 0 56 56" version="1.1" {...props}>
    <g
      id="logos/barracuda/Web-Security-Gateway"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-7" fillRule="nonzero">
        <rect
          id="Rectangle"
          fill="#0088CE"
          x="0"
          y="0"
          width="56"
          height="56"
        />
        <path
          d="M30.8485333,8.50826667 C32.5957333,8.50826667 33.8874667,8.8928 34.7274667,9.32213333 L34.0106667,11.6928 C33.4357333,11.3829333 32.312,10.9274667 30.8037333,10.9274667 C28.9370667,10.9274667 28.1232,11.9317333 28.1232,12.8650667 C28.1232,14.1082667 29.0565333,14.6832 31.2106667,15.5232 C34.0106667,16.576 35.3770667,17.9909333 35.3770667,20.3130667 C35.3770667,22.9002667 33.4133333,25.1477333 29.2469333,25.1477333 C27.5482667,25.1477333 25.7749333,24.6698667 24.8901333,24.1434667 L25.536,21.6981333 C26.4954667,22.2506667 27.9290667,22.7285333 29.4373333,22.7285333 C31.3301333,22.7285333 32.3829333,21.8437333 32.3829333,20.5258667 C32.3829333,19.3050667 31.5690667,18.5882667 29.5082667,17.8453333 C26.8501333,16.8858667 25.1514667,15.4746667 25.1514667,13.1525333 C25.1514667,10.5205333 27.3541333,8.50826667 30.8485333,8.50826667 Z M45.6213333,8.60533333 C47.6074667,8.60533333 49.1642667,9.01226667 49.9072,9.37066667 L49.2613333,11.7413333 C48.3765333,11.3568 47.2976,11.0469333 45.5989333,11.0469333 C42.1493333,11.0469333 39.7338667,13.0816 39.7338667,16.8410667 C39.7338667,20.5034667 41.9850667,22.6837333 45.3376,22.6837333 C46.3904,22.6837333 47.1818667,22.5418667 47.5626667,22.3477333 L47.5626667,18.3232 L44.7141333,18.3232 L44.7141333,16.0010667 L50.4112,16.0010667 L50.4112,24.1658667 C49.3808,24.5504 47.3722667,25.0768 45.2144,25.0768 C42.4853333,25.0768 40.4245333,24.3824 38.8938667,22.9226667 C37.4565333,21.5562667 36.6202667,19.4282667 36.6426667,16.9866667 C36.6426667,11.8869333 40.2826667,8.60533333 45.6213333,8.60533333 Z M15.9338667,8.76586667 L17.5392,16.1877333 C17.9461333,18.1029333 18.2821333,19.8986667 18.5210667,21.6458667 L18.5696,21.6458667 C18.8570667,19.8725333 19.2416,18.032 19.6709333,16.0682667 L21.3472,8.76586667 L24.3413333,8.76586667 L20.0032,24.9050667 L16.8448,24.9050667 L15.1685333,17.3152 C14.7616,15.4709333 14.4741333,13.9402667 14.2837333,12.1930667 L14.2352,12.1930667 C13.9477333,13.9178667 13.6378667,15.4746667 13.1562667,17.3152 L11.2896,24.9050667 L8.10506667,24.9050667 L4.1552,8.7696 L7.2912,8.7696 L8.8256,16.0944 C9.23253333,18.0581333 9.61706667,20.1152 9.8784,21.7205333 L9.92693333,21.7205333 C10.192,20.0218667 10.6437333,18.1066667 11.0992,16.0682667 L12.8464,8.76586667 L15.9338667,8.76586667 Z"
          id="Combined-Shape"
          fill="#FFFFFF"
        />
      </g>
    </g>
  </svg>
);

export const BCSIcon = ({ ...props }) => (
  <SvgIcon
    width="56px"
    height="56px"
    viewBox="0 0 56 56"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>logos/Content Shield</title>
    <g
      id="logos/Content-Shield"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="element_icon_cs" fillRule="nonzero">
        <g id="Spam_Firewall" fill="#0088CE">
          <rect id="Rectangle-path" x="0" y="0" width="56" height="56" />
        </g>
        <path
          d="M16.4602667,24.4272 C15.7658667,24.8005333 14.2202667,25.144 12.2938667,25.144 C7.17173333,25.144 4.05813333,21.9370667 4.05813333,17.0277333 C4.05813333,11.7152 7.74293333,8.50453333 12.6784,8.50453333 C14.616,8.50453333 16.0048,8.91146667 16.6021333,9.22506667 L15.9562667,11.5733333 C14.9581555,11.1485338 13.8825297,10.9362058 12.7978667,10.9498667 C9.51626667,10.9498667 7.1456,13.0106667 7.1456,16.8896 C7.1456,20.4325333 9.2288,22.7061333 12.7717333,22.7061333 C13.8710056,22.7222314 14.9624703,22.5191682 15.9824,22.1088 L16.4602667,24.4272 Z"
          id="Shape"
          fill="#FFFFFF"
        />
        <path
          d="M19.1632,21.6981333 C20.3578205,22.3637987 21.7007431,22.7181455 23.0682667,22.7285333 C24.9573333,22.7285333 26.0138667,21.84 26.0138667,20.5258667 C26.0138667,19.3050667 25.2,18.5845333 23.1392,17.8416 C20.4810667,16.8858667 18.7824,15.4746667 18.7824,13.1488 C18.7824,10.5354667 20.9850667,8.50453333 24.4794667,8.50453333 C25.8245837,8.4702541 27.1587726,8.75423295 28.3733333,9.33333333 L27.6266667,11.6890667 C26.6330119,11.1829965 25.5309936,10.9267132 24.416,10.9424 C22.5493333,10.9424 21.7354667,11.9466667 21.7354667,12.8837333 C21.7354667,14.1269333 22.6688,14.7018667 24.8229333,15.5381333 C27.6266667,16.576 29.0042667,17.9872 29.0042667,20.3093333 C29.0042667,22.8965333 27.0405333,25.144 22.8778667,25.144 C21.1754667,25.144 19.4058667,24.6661333 18.5173333,24.1397333 L19.1632,21.6981333 Z"
          id="Shape"
          fill="#FFFFFF"
        />
      </g>
    </g>
  </SvgIcon>
);

export const EmailIcon = ({ ...props }) => (
  <SvgIcon viewBox="0 0 16 14" {...props}>
    <title>Email Icon</title>
    <path
      d="M14.4.6H1.6C.72.6 0 1.32 0 2.2v9.6c0 .88.72 1.6 1.6 1.6h12.8c.88 0 1.6-.72 1.6-1.6V2.2c0-.88-.72-1.6-1.6-1.6zm0 3.2L8 7.8l-6.4-4V2.2l6.4 4 6.4-4v1.6z"
      fill="#5F5F5F"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const CircleIcon = ({ ...props }) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <circle cx="10" cy="10" r="10" />
  </SvgIcon>
);

export const PeopleIcon = ({ secondaryColor, ...props }) => (
  <SvgIcon
    viewBox="0 0 20 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="[30]-Local-Users"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="[29a2]-Users---Directory-Services-Configured"
        transform="translate(-242.000000, -92.000000)"
      >
        <g
          id="icons/component/color/downloads"
          transform="translate(240.000000, 88.000000)"
        >
          <path
            d="M9.05882353,10.9230769 C11.0588235,10.9230769 12.5882353,9.42307692 12.5882353,7.46153846 C12.5882353,5.5 11.0588235,4 9.05882353,4 C7.05882353,4 5.52941176,5.5 5.52941176,7.46153846 C5.52941176,9.42307692 7.05882353,10.9230769 9.05882353,10.9230769 L9.05882353,10.9230769 Z M2,16.6923077 L2,20 L16.1176471,20 L16.1176471,16.6923077 C16.1176471,14.3846154 11.4117647,13.2307692 9.05882353,13.2307692 C6.70588235,13.2307692 2,14.3846154 2,16.6923077 Z"
            id="icn-user"
            fill="currentColor"
          />
          <path
            d="M14.9411765,10.9230769 C14.5882353,10.9230769 14.2352941,10.8076923 13.8823529,10.8076923 C14.5882353,9.76923077 14.9411765,8.73076923 14.9411765,7.46153846 C14.9411765,6.19230769 14.5882353,5.15384615 13.8823529,4.11538462 C14.2352941,4.11538462 14.5882353,4 14.9411765,4 C16.9411765,4 18.4705882,5.5 18.4705882,7.46153846 C18.4705882,9.42307692 16.9411765,10.9230769 14.9411765,10.9230769 Z M18.4705882,16.6923077 C18.4705882,15.4230769 17.7647059,14.2692308 16.8235294,13.4615385 C19.1764706,13.8076923 22,14.9615385 22,16.6923077 L22,20 L18.4705882,20 L18.4705882,16.6923077 Z"
            id="icn-user2"
            fill={secondaryColor || 'currentColor'}
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const PersonIcon = ({ ...props }) => (
  <SvgIcon
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="[30]-Local-Users"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="[29e1]-SMB-Customer---Expanded"
        transform="translate(-320.000000, -651.000000)"
        fill="currentColor"
        fillRule="nonzero"
      >
        <g id="Group-3" transform="translate(240.000000, 393.000000)">
          <g id="Group">
            <g
              id="icons/gray/identity"
              transform="translate(76.000000, 254.000000)"
            >
              <path
                d="M12,5.9 C13.16,5.9 14.1,6.84 14.1,8 C14.1,9.16 13.16,10.1 12,10.1 C10.84,10.1 9.9,9.16 9.9,8 C9.9,6.84 10.84,5.9 12,5.9 L12,5.9 Z M12,14.9 C14.975,14.9 18.1,16.355 18.1,17 L18.1,18.1 L5.9,18.1 L5.9,17 C5.9,16.355 9.025,14.9 12,14.9 L12,14.9 Z M12,4 C9.79,4 8,5.79 8,8 C8,10.205 9.79,12 12,12 C14.21,12 16,10.205 16,8 C16,5.79 14.21,4 12,4 Z M12,13 C9.335,13 4,14.335 4,17 L4,20 L20,20 L20,17 C20,14.335 14.665,13 12,13 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const ExpandIcon = ({ ...props }) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g
      id="icons/color/expand"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M4,5.99406028 C4,4.8927712 4.89451376,4 5.99406028,4 L18.0059397,4 C19.1072288,4 20,4.89451376 20,5.99406028 L20,18.0059397 C20,19.1072288 19.1054862,20 18.0059397,20 L5.99406028,20 C4.8927712,20 4,19.1054862 4,18.0059397 L4,5.99406028 Z"
        id="Path"
        fill="#FFFFFF"
        fillRule="nonzero"
      />
      <path
        d="M4,5.99406028 C4,4.8927712 4.89451376,4 5.99406028,4 L18.0059397,4 C19.1072288,4 20,4.89451376 20,5.99406028 L20,18.0059397 C20,19.1072288 19.1054862,20 18.0059397,20 L5.99406028,20 C4.8927712,20 4,19.1054862 4,18.0059397 L4,5.99406028 Z M5,5.99406028 L5,18.0059397 C5,18.5539384 5.44579254,19 5.99406028,19 L18.0059397,19 C18.5539384,19 19,18.5542075 19,18.0059397 L19,5.99406028 C19,5.44606163 18.5542075,5 18.0059397,5 L5.99406028,5 C5.44606163,5 5,5.44579254 5,5.99406028 Z"
        id="Rectangle-14"
        fill="#BBBBBB"
        fillRule="nonzero"
      />
      <path
        d="M11,11 L11,8 L13,8 L13,11 L16,11 L16,13 L13,13 L13,16 L11,16 L11,13 L8,13 L8,11 L11,11 Z"
        id="Combined-Shape"
        fill="#5F5F5F"
      />
    </g>
  </SvgIcon>
);

export const CollapseIcon = ({ ...props }) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g
      id="icons/color/collapse"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M4,5.99406028 C4,4.8927712 4.89451376,4 5.99406028,4 L18.0059397,4 C19.1072288,4 20,4.89451376 20,5.99406028 L20,18.0059397 C20,19.1072288 19.1054862,20 18.0059397,20 L5.99406028,20 C4.8927712,20 4,19.1054862 4,18.0059397 L4,5.99406028 Z"
        id="Path"
        fill="#FFFFFF"
        fillRule="nonzero"
      />
      <path
        d="M4,5.99406028 C4,4.8927712 4.89451376,4 5.99406028,4 L18.0059397,4 C19.1072288,4 20,4.89451376 20,5.99406028 L20,18.0059397 C20,19.1072288 19.1054862,20 18.0059397,20 L5.99406028,20 C4.8927712,20 4,19.1054862 4,18.0059397 L4,5.99406028 Z M5,5.99406028 L5,18.0059397 C5,18.5539384 5.44579254,19 5.99406028,19 L18.0059397,19 C18.5539384,19 19,18.5542075 19,18.0059397 L19,5.99406028 C19,5.44606163 18.5542075,5 18.0059397,5 L5.99406028,5 C5.44606163,5 5,5.44579254 5,5.99406028 Z"
        id="Rectangle-14"
        fill="#BBBBBB"
        fillRule="nonzero"
      />
      <polygon id="icn-minus" fill="#5F5F5F" points="8 11 16 11 16 13 8 13" />
    </g>
  </SvgIcon>
);

export const BlockpageIcon = ({ ...props }) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <g
      id="[18]-Block-Page"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="[18x1a]-Block-Page---Default---BCS"
        transform="translate(-244.000000, -127.000000)"
      >
        <g
          id="icons/component/color/block-page"
          transform="translate(242.000000, 125.000000)"
        >
          <path
            d="M8.12399283,20 C9.27224261,20.6371629 10.5937487,21 12,21 C13.4062513,21 14.7277574,20.6371629 15.8760072,20 L18.9991283,20 C19.5553691,20 20,19.5529553 20,19.0014977 L20,7 L17.2916488,7 C15.8813824,5.75527318 14.0288929,5 12,5 C9.97110706,5 8.11861761,5.75527318 6.70835121,7 L4,7 L4,19.0014977 C4,19.5525106 4.4481055,20 5.00087166,20 L8.12399283,20 Z M2,3.99079514 C2,2.89130934 2.89821238,2 3.99079514,2 L20.0092049,2 C21.1086907,2 22,2.89821238 22,3.99079514 L22,20.0092049 C22,21.1086907 21.1017876,22 20.0092049,22 L3.99079514,22 C2.89130934,22 2,21.1017876 2,20.0092049 L2,3.99079514 Z M18,4 L18,5 L20,5 L20,4 L18,4 Z M14,4 L14,5 L16,5 L16,4 L14,4 Z M10,4 L10,5 L12,5 L12,4 L10,4 Z"
            id="Combined-Shape"
            fill="#5F5F5F"
          />
          <path
            d="M12,19 C8.6862915,19 6,16.3137085 6,13 C6,9.6862915 8.6862915,7 12,7 C15.3137085,7 18,9.6862915 18,13 C18,16.3137085 15.3137085,19 12,19 Z M8,12 L8,14 L16,14 L16,12 L8,12 Z"
            id="Combined-Shape"
            fill="#0088CE"
            fillRule="nonzero"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const CompanyIcon = ({ ...props }) => {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <title>Company Icon</title>
      <path
        d="M12 4V2.60391006C12 2.04019699 11.5536144 1.6 11.0029699 1.6H4.99703014C4.45303631 1.6 4 2.04946585 4 2.60391006V4h8zm.8 0h2.1991283C15.5518945 4 16 4.45576096 16 5.00247329v9.99505341C16 15.5511774 15.5553691 16 14.9991283 16H1.00087166C.4481055 16 0 15.544239 0 14.9975267V5.00247329C0 4.44882258.44463086 4 1.00087166 4H3.2V1.0093689C3.2.45190985 3.65015178 0 4.19121056 0h7.61757884C12.3562199 0 12.8.44335318 12.8 1.0093689V4z"
        fill="#5F5F5F"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};

export const DarkLockIcon = ({ ...props }) => {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <title>Lock Icon</title>
      <path
        d="M11 5.6V4c0-2.24-1.76-4-4-4S3 1.76 3 4v1.6h-.8c-.88 0-1.6.72-1.6 1.6v7.2c0 .88.72 1.6 1.6 1.6h9.6c.88 0 1.6-.72 1.6-1.6V7.2c0-.88-.72-1.6-1.6-1.6H11zM7 12c-.88 0-1.6-.72-1.6-1.6 0-.88.72-1.6 1.6-1.6.88 0 1.6.72 1.6 1.6 0 .88-.72 1.6-1.6 1.6zm2.48-6.4H4.52V4c0-1.36 1.12-2.48 2.48-2.48 1.36 0 2.48 1.12 2.48 2.48v1.6z"
        fill="#5F5F5F"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};

export const FormUserIcon = ({ ...props }) => {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <title>User Icon</title>
      <path
        d="M8 8c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm0 2c-2.7 0-8 1.3-8 4v2h16v-2c0-2.7-5.3-4-8-4z"
        fill="#5F5F5F"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};
export const LocationIcon = ({ ...props }) => {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <title>Location Icon</title>
      <path
        d="M6 0C2.88 0 .4 2.48.4 5.6.4 9.76 6 16 6 16s5.6-6.24 5.6-10.4C11.6 2.48 9.12 0 6 0zm0 7.6c-1.12 0-2-.88-2-2s.88-2 2-2 2 .88 2 2-.88 2-2 2z"
        fill="#5F5F5F"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};
export const PhoneIcon = ({ ...props }) => {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <title>Phone Icon</title>
      <path
        d="M11.9111111 10.5777778c-.2666667-.0888889-.6222222 0-.8888889.1777778l-1.95555553 1.9555555C6.57777778 11.4666667 4.53333333 9.33333333 3.2 6.84444444l1.95555556-1.95555555C5.42222222 4.62222222 5.51111111 4.26666667 5.33333333 4c-.26666666-.97777778-.44444444-2.04444444-.44444444-3.11111111C4.88888889.35555556 4.53333333 0 4 0H.88888889C.35555556 0 0 .35555556 0 .88888889 0 9.24444444 6.75555556 16 15.1111111 16 15.6444444 16 16 15.6444444 16 15.1111111V12c0-.5333333-.3555556-.8888889-.8888889-.8888889-1.0666667 0-2.1333333-.1777778-3.2-.5333333z"
        fill="#5F5F5F"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};
export const InfinityIcon = props => (
  <SvgIcon
    width="20px"
    height="10px"
    viewBox="0 0 20 10"
    version="1.1"
    {...props}
  >
    <defs />
    <g
      id="[04]-SMB-Account---Dashboard"
      stroke="none"
      strokeWidth="1"
      fillRule="evenodd"
    >
      <path
        d="M4.49049529,10 C3.28938622,10 2.16181444,9.47978723 1.31564536,8.53617021 C0.76852792,7.92553191 0.331226168,7.08191489 0.144931701,6.27978723 C-0.186476353,4.85425532 0.0566869525,3.34680851 0.810689299,2.14361702 C1.54214021,0.977659574 2.69422442,0.205319149 3.97279277,0.0265957447 C4.1031989,0.0085106383 4.24537099,0 4.39244557,0 C4.89642113,0 5.4670705,0.1 5.92006021,0.268085106 C6.63484267,0.535106383 7.12313027,0.903191489 7.92811847,1.78191489 L8.67917933,2.6212766 L7.86340566,3.53617021 L7.18097961,2.77446809 C6.57895433,2.11170213 6.35736196,1.91702128 5.93574816,1.67659574 C5.50825138,1.43723404 5.00819781,1.3106383 4.49049529,1.3106383 C3.93357288,1.3106383 3.39626042,1.45425532 2.93542673,1.72553191 C1.8255039,2.37340426 1.16268779,3.59787234 1.16268779,5.00212766 C1.16268779,6.43191489 1.84609434,7.67021277 2.99033457,8.31382979 C3.42861682,8.56170213 3.93847537,8.69255319 4.46402187,8.69255319 C5.20527775,8.69255319 5.91123573,8.4393617 6.45345069,7.97978723 C6.58385681,7.86914894 8.25854603,6.0287234 9.68124747,4.44574468 C11.240238,2.71382979 12.7198083,1.08404255 12.9845425,0.885106383 C13.7767843,0.288297872 14.584714,0.00957446809 15.5289328,0.00957446809 C16.0652647,0.00957446809 16.4437367,0.0755319149 16.9251608,0.253191489 C18.2302026,0.723404255 19.286198,1.87553191 19.7529147,3.33510638 C20.0823618,4.36595745 20.0823618,5.64255319 19.7529147,6.66914894 C19.1136305,8.65957447 17.4154094,9.99574468 15.5269718,9.99574468 C14.914161,9.99574468 14.3131162,9.85638298 13.7414864,9.58191489 C13.17672,9.30957447 12.7413792,8.95319149 12.0736606,8.21808511 L11.2990678,7.37553191 L12.113861,6.46170213 L12.819819,7.22978723 C13.4218443,7.89148936 13.6424562,8.08723404 14.0660309,8.32765957 C14.4964692,8.56702128 14.9975033,8.69361702 15.5171668,8.69361702 C16.0701672,8.69361702 16.6055187,8.55212766 17.0653719,8.28297872 C17.7232855,7.89361702 18.1801972,7.36702128 18.5047418,6.62765957 C18.75771,6.05851064 18.8430133,5.64787234 18.8430133,5.00212766 C18.8430133,4.35851064 18.7586905,3.94893617 18.5096443,3.37659574 C18.1733337,2.61170213 17.6919096,2.07659574 16.9957566,1.69361702 C16.4947225,1.41382979 16.1103676,1.31382979 15.5289328,1.31382979 L15.5279523,1.31382979 C14.8053258,1.31382979 14.225852,1.51489362 13.6248072,1.96595745 C13.4542007,2.08723404 11.2716139,4.50319149 10.3411221,5.53510638 C7.26236088,8.95638298 7.08292989,9.1393617 6.51031952,9.46276596 C5.8877038,9.81382979 5.1886093,10 4.49049529,10"
        id="Fill-1"
      />
    </g>
  </SvgIcon>
);

export const DragVerticalIcon = props => (
  <SvgIcon
    width="5px"
    height="32px"
    viewBox="0 0 5 32"
    version="1.1"
    {...props}
  >
    <g
      id="[28]-Advanced-Filtering"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="[25a]-SMB-Account---Advanced-Filtering-Default-Policy-Copy"
        transform="translate(-284.000000, -398.000000)"
        fill="#DDDDDD"
      >
        <g id="Group" transform="translate(284.000000, 398.000000)">
          <rect id="Rectangle-2" x="0" y="0" width="2" height="2" />
          <rect id="Rectangle-2" x="3" y="0" width="2" height="2" />
          <rect id="Rectangle-2" x="0" y="3" width="2" height="2" />
          <rect id="Rectangle-2" x="3" y="3" width="2" height="2" />
          <rect id="Rectangle-2" x="0" y="6" width="2" height="2" />
          <rect id="Rectangle-2" x="3" y="6" width="2" height="2" />
          <rect id="Rectangle-2" x="0" y="9" width="2" height="2" />
          <rect id="Rectangle-2" x="3" y="9" width="2" height="2" />
          <rect id="Rectangle-2" x="0" y="12" width="2" height="2" />
          <rect id="Rectangle-2" x="3" y="12" width="2" height="2" />
          <rect id="Rectangle-2" x="0" y="15" width="2" height="2" />
          <rect id="Rectangle-2" x="3" y="15" width="2" height="2" />
          <rect id="Rectangle-2" x="0" y="18" width="2" height="2" />
          <rect id="Rectangle-2" x="3" y="18" width="2" height="2" />
          <rect id="Rectangle-2" x="0" y="21" width="2" height="2" />
          <rect id="Rectangle-2" x="3" y="21" width="2" height="2" />
          <rect id="Rectangle-2" x="0" y="24" width="2" height="2" />
          <rect id="Rectangle-2" x="3" y="24" width="2" height="2" />
          <rect id="Rectangle-2" x="0" y="27" width="2" height="2" />
          <rect id="Rectangle-2" x="3" y="27" width="2" height="2" />
          <rect id="Rectangle-2" x="0" y="30" width="2" height="2" />
          <rect id="Rectangle-2" x="3" y="30" width="2" height="2" />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const WebLogIcon = props => (
  <SvgIcon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    {...props}
  >
    <title>icons/component/color/basic filtering logs</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="nonzero">
      <path
        d="M2,8.9997 L4,8.9997 L4,6.9997 L2,6.9997 L2,8.9997 Z M2,13.9997 L4,13.9997 L4,9.9997 L2,9.9997 L2,13.9997 Z M2,17.9997 L4,17.9997 L4,14.9997 L2,14.9997 L2,17.9997 Z M6.764,17.9997 C7.303,18.7577 7.95,19.4307 8.684,19.9997 L1.991,19.9997 C0.892,19.9997 0,19.1057 0,18.0077 L0,4.9997 L8.684,4.9997 C7.95,5.5697 7.303,6.2427 6.764,6.9997 L5,6.9997 L5,17.9997 L6.764,17.9997 Z M20,1.009 L20,4 L0,4 L0,1.009 C0,0.452 0.455,0 0.992,0 L19.008,0 C19.556,0 20,0.443 20,1.009 Z"
        id="Fill-3"
        fill="#5F5F5F"
      />
      <path
        d="M13.75,18.4245 C10.825,18.0495 8.5,15.4995 8.5,12.4995 C8.5,12.0495 8.575,11.5995 8.65,11.1495 L12.25,14.7495 L12.25,15.4995 C12.25,16.3245 12.925,16.9995 13.75,16.9995 L13.75,18.4245 Z M20,14.8745 C19.732,15.4955 19.374,16.0665 18.925,16.5495 C18.7,15.9495 18.175,15.4995 17.5,15.4995 L16.75,15.4995 L16.75,13.2495 C16.75,12.7995 16.45,12.4995 16,12.4995 L11.5,12.4995 L11.5,10.9995 L13,10.9995 C13.45,10.9995 13.75,10.6995 13.75,10.2495 L13.75,8.7495 L15.25,8.7495 C16.075,8.7495 16.75,8.0745 16.75,7.2495 L16.75,6.9495 C18.201,7.5505 19.373,8.7255 20,10.1725 L20,7.4255 C18.627,5.9395 16.671,4.9995 14.5,4.9995 C10.375,4.9995 7,8.3745 7,12.4995 C7,16.6245 10.375,19.9995 14.5,19.9995 C16.671,19.9995 18.627,19.0595 20,17.5725 L20,14.8745 Z"
        id="Fill-5"
        fill="#0088CE"
      />
    </g>
  </SvgIcon>
);

export const AdvancedFilteringIcon = props => (
  <SvgIcon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    {...props}
  >
    <title>icons/component/color/advanced filtering</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="nonzero">
      <path
        d="M20,9.085897 C19.5236347,8.3772353 18.8652596,7.86581921 18,7.52677413 L18,5 L2,5 L2,17.0014977 C2,17.5525106 2.4481055,18 3.00087166,18 L7,18 L7,20 L1.99079514,20 C0.89130934,20 0,19.1017876 0,18.0092049 L0,1.99079514 C0,0.89130934 0.89821238,0 1.99079514,0 L18.0092049,0 C19.1086907,0 20,0.89821238 20,1.99079514 L20,9.085897 Z M16,2 L16,3 L18,3 L18,2 L16,2 Z M12,2 L12,3 L14,3 L14,2 L12,2 Z M8,2 L8,3 L10,3 L10,2 L8,2 Z"
        id="application-frame"
        fill="#5F5F5F"
      />
      <path
        d="M14.5,13 C15.88,13 16.99,11.88 16.99,10.5 C16.99,9.12 15.88,8 14.5,8 C13.12,8 12,9.12 12,10.5 C12,11.88 13.12,13 14.5,13 Z M14.5,15 C12.665,15 9,15.92 9,17.75 L9,20 L20,20 L20,17.75 C20,15.92 16.335,15 14.5,15 Z"
        id="Shape"
        fill="#0088CE"
      />
    </g>
  </SvgIcon>
);

export const SerialIcon = props => (
  <SvgIcon viewBox="0 0 16 14" {...props}>
    <title>Serial Icon</title>
    <path
      d="M14.2222222 0C15.2 0 16 .7875 16 1.75v10.5c0 .9625-.8 1.75-1.7777778 1.75H1.77777778C.8 14 0 13.2125 0 12.25V1.75C0 .7875.8 0 1.77777778 0H14.2222222zM2 4v6h1V4H2zm10 0v6h2V4h-2zM7 4v6h2V4H7zM4 4v6h1V4H4zm6 0v6h1V4h-1z"
      fill="#5F5F5F"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const LinkingIcon = props => (
  <SvgIcon viewBox="0 0 16 10" {...props}>
    <title>Link Icon</title>
    <g fill="#5F5F5F" fillRule="evenodd">
      <path d="M5 5.83333333h6V4.16666667H5z" />
      <path d="M5 1.58333333h2V0H5C2.25 0 0 2.25 0 5s2.25 5 5 5h2V8.41666667H5c-1.91666667 0-3.41666667-1.5-3.41666667-3.41666667 0-1.91666667 1.5-3.41666667 3.41666667-3.41666667zM11 1.58333333H9V0h2c2.75 0 5 2.25 5 5s-2.25 5-5 5H9V8.41666667h2c1.9166667 0 3.4166667-1.5 3.4166667-3.41666667 0-1.91666667-1.5-3.41666667-3.4166667-3.41666667z" />
    </g>
  </SvgIcon>
);

export const ChevronDoubleDownIcon = props => (
  <SvgIcon
    height="24px"
    width="24px"
    viewBox="0 0 24 24"
    version="1.1"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.59,5.59L18,7L12,13L6,7L7.41,5.59L12,10.17L16.59,5.59M16.59,11.59L18,13L12,19L6,13L7.41,11.59L12,16.17L16.59,11.59Z"
    />
  </SvgIcon>
);

export const ChevronDoubleUpIcon = props => (
  <SvgIcon
    height="24px"
    width="24px"
    viewBox="0 0 24 24"
    version="1.1"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.41,18.41L6,17L12,11L18,17L16.59,18.41L12,13.83L7.41,18.41M7.41,12.41L6,11L12,5L18,11L16.59,12.41L12,7.83L7.41,12.41Z"
    />
  </SvgIcon>
);

export const WebIcon = props => (
  <SvgIcon
    height="24px"
    width="24px"
    viewBox="0 0 24 24"
    version="1.1"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
    />
  </SvgIcon>
);

export const AccountIcon = props => (
  <SvgIcon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    {...props}
  >
    <defs />
    <g
      id="icons/accounts"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M2,1 L18,1 L18,0 L2,0 L2,1 Z M1,3 L19,3 L19,2 L1,2 L1,3 Z M2,16 L18,16 L18,6 L2,6 L2,16 Z M19,4 L1,4 C0.448,4 0,4.447 0,5 L0,16 L0,19 C0,19.553 0.448,20 1,20 L4,20 L4,19 C3.448,19 3,18.553 3,18 C3,17.447 3.448,17 4,17 L5,17 C5.552,17 6,17.447 6,18 C6,18.553 5.552,19 5,19 L5,20 L15,20 L15,19 C14.448,19 14,18.553 14,18 C14,17.447 14.448,17 15,17 L16,17 C16.553,17 17,17.447 17,18 C17,18.553 16.553,19 16,19 L16,20 L19,20 C19.553,20 20,19.553 20,19 L20,16 L20,5 C20,4.447 19.553,4 19,4 Z"
        id="Fill-7"
        fill="#5F5F5F"
      />
      <path
        d="M12,9 L12,7 L17,7 L17,9 L12,9 Z M12,12 L12,10 L17,10 L17,12 L12,12 Z M7,11 C5.9,11 5,10.1 5,9 C5,7.9 5.9,7 7,7 C8.1,7 9,7.9 9,9 C9,10.1 8.1,11 7,11 Z M7,12 C8.35,12 11,12.65 11,14 L11,15 L3,15 L3,14 C3,12.65 5.65,12 7,12 Z"
        id="Combined-Shape"
        fill="#0088CE"
      />
    </g>
  </SvgIcon>
);

export const BasicFilterIcon = props => (
  <SvgIcon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    {...props}
  >
    <defs />
    <g
      id="icons/basic-filtering"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M20,8.70835121 C19.4280725,8.06036148 18.7528104,7.50573486 18,7.07025756 L18,5 L2,5 L2,17.0014977 C2,17.5525106 2.4481055,18 3.00087166,18 L7.07025756,18 C7.50573486,18.7528104 8.06036148,19.4280725 8.70835121,20 L1.99079514,20 C0.891309342,20 0,19.1017876 0,18.0092049 L0,1.99079514 C0,0.891309342 0.898212381,0 1.99079514,0 L18.0092049,0 C19.1086907,0 20,0.898212381 20,1.99079514 L20,8.70835121 Z M16,2 L16,3 L18,3 L18,2 L16,2 Z M12,2 L12,3 L14,3 L14,2 L12,2 Z M8,2 L8,3 L10,3 L10,2 L8,2 Z"
        id="application-frame-copy"
        fill="#5E5F5F"
      />
      <path
        d="M14,18 C13.261,18 12.576,17.784 11.98,17.434 L17.434,11.98 C17.784,12.576 18,13.261 18,14 C18,16.205 16.206,18 14,18 M14,10 C14.739,10 15.424,10.216 16.02,10.566 L10.566,16.02 C10.216,15.424 10,14.739 10,14 C10,11.794 11.794,10 14,10 M14,8 C10.687,8 8,10.687 8,14 C8,17.313 10.687,20 14,20 C17.313,20 20,17.313 20,14 C20,10.687 17.313,8 14,8"
        id="Fill-1"
        fill="#0088CE"
      />
    </g>
  </SvgIcon>
);

export const CheckboxMarkedOutline = props => (
  <SvgIcon height="24px" width="24px" viewBox="0 0 24 24" {...props}>
    <defs />
    <g id="icons/checkbox-marked-outline">
      <path
        fill="#000000"
        d="M19,19H5V5H15V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V11H19M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
      />
    </g>
  </SvgIcon>
);

export const UpArrow = props => (
  <SvgIcon width="8px" height="9px" viewBox="0 0 8 9" {...props}>
    <defs />
    <g
      id="upArrow"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <polygon
        id="Path"
        fill="currentColor"
        transform="translate(4.000000, 4.500000) scale(1, -1) translate(-4.000000, -4.500000) "
        points="5 0 3 0 3 5 0 5 4 9 8 5 5 5"
      />
    </g>
  </SvgIcon>
);

export const DownArrow = props => (
  <SvgIcon width="8px" height="9px" viewBox="0 0 8 9" {...props}>
    <defs />
    <g
      id="upArrow"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <polygon
        id="Path"
        fill="currentColor"
        points="5 0 3 0 3 5 0 5 4 9 8 5 5 5"
      />
    </g>
  </SvgIcon>
);

export const CASIcon = props => (
  <SvgIcon width="34px" height="34px" viewBox="0 0 34 34" {...props}>
    <defs />
    <g
      id="icn-cas"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icn-cas_34x34-@2x">
        <polygon id="Fill-1" fill="#FF9E1B" points="0 34 34 34 34 0 0 0" />
        <g
          id="Group-8"
          transform="translate(2.000000, 5.000000)"
          fill="#FFFFFF"
        >
          <path
            d="M8.0547,9.7077 C7.6337,9.9257 6.7027,10.1437 5.5257,10.1437 C2.4157,10.1437 0.5257,8.1957 0.5257,5.2167 C0.5257,1.9897 2.7637,0.0417 5.7577,0.0417 C6.9357,0.0417 7.7787,0.2897 8.1417,0.4787 L7.7497,1.9027 C7.2847,1.6987 6.6447,1.5247 5.8307,1.5247 C3.8397,1.5247 2.4007,2.7747 2.4007,5.1297 C2.4007,7.2807 3.6647,8.6617 5.8167,8.6617 C6.5427,8.6617 7.2987,8.5157 7.7637,8.2977 L8.0547,9.7077 Z"
            id="Fill-2"
          />
          <path
            d="M14.6816,5.8705 L13.9116,3.4575 C13.7226,2.8615 13.5626,2.1935 13.4176,1.6265 L13.3876,1.6265 C13.2426,2.1935 13.0976,2.8765 12.9226,3.4575 L12.1676,5.8705 L14.6816,5.8705 Z M11.8766,7.2225 L11.0336,9.9985 L9.1876,9.9985 L12.3276,0.2015 L14.6086,0.2015 L17.7916,9.9985 L15.8736,9.9985 L14.9866,7.2225 L11.8766,7.2225 Z"
            id="Fill-4"
          />
          <path
            d="M19.2566,8.0507 C19.8376,8.3847 20.7096,8.6757 21.6256,8.6757 C22.7736,8.6757 23.4136,8.1377 23.4136,7.3387 C23.4136,6.5977 22.9196,6.1617 21.6696,5.7107 C20.0566,5.1297 19.0246,4.2717 19.0246,2.8617 C19.0246,1.2627 20.3616,0.0417 22.4836,0.0417 C23.5446,0.0417 24.3296,0.2747 24.8376,0.5367 L24.4016,1.9757 C24.0536,1.7867 23.3696,1.5097 22.4546,1.5097 C21.3206,1.5097 20.8266,2.1207 20.8266,2.6877 C20.8266,3.4437 21.3936,3.7917 22.7016,4.3007 C24.4016,4.9407 25.2306,5.7977 25.2306,7.2077 C25.2306,8.7777 24.0386,10.1437 21.5096,10.1437 C20.4776,10.1437 19.4016,9.8527 18.8646,9.5337 L19.2566,8.0507 Z"
            id="Fill-6"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const CCBIcon = props => (
  <SvgIcon width="34px" height="34px" viewBox="0 0 34 34" {...props}>
    <defs />
    <g
      id="icn-ccb"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icn-ccb_34x34-@2x">
        <polygon id="Fill-1" fill="#FF9E1B" points="0 34 34 34 34 0 0 0" />
        <path
          d="M10.0547,14.7077 C9.6337,14.9257 8.7027,15.1437 7.5257,15.1437 C4.4157,15.1437 2.5257,13.1957 2.5257,10.2167 C2.5257,6.9897 4.7637,5.0417 7.7577,5.0417 C8.9357,5.0417 9.7787,5.2897 10.1417,5.4787 L9.7497,6.9027 C9.2847,6.6987 8.6447,6.5247 7.8307,6.5247 C5.8397,6.5247 4.4007,7.7747 4.4007,10.1297 C4.4007,12.2807 5.6647,13.6617 7.8167,13.6617 C8.5427,13.6617 9.2987,13.5157 9.7637,13.2977 L10.0547,14.7077 Z"
          id="Fill-2"
          fill="#FFFFFF"
        />
        <path
          d="M18.529,14.666 C18.108,14.884 17.177,15.102 16,15.102 C12.89,15.102 11,13.154 11,10.175 C11,6.948 13.238,5 16.232,5 C17.41,5 18.253,5.248 18.616,5.437 L18.224,6.861 C17.759,6.657 17.119,6.483 16.305,6.483 C14.314,6.483 12.875,7.733 12.875,10.088 C12.875,12.239 14.139,13.62 16.291,13.62 C17.017,13.62 17.773,13.474 18.238,13.256 L18.529,14.666 Z"
          id="Fill-2"
          fill="#FFFFFF"
        />
        <path
          d="M22.2306,13.7487 C22.4636,13.7927 22.7686,13.7927 23.1756,13.7927 C24.3236,13.7927 25.3556,13.3707 25.3556,12.1647 C25.3556,11.0157 24.3526,10.5507 23.1176,10.5507 L22.2306,10.5507 L22.2306,13.7487 Z M22.2306,9.2577 L23.1466,9.2577 C24.3966,9.2577 25.0796,8.6757 25.0796,7.8477 C25.0796,6.9177 24.3816,6.4957 23.2486,6.4957 C22.7246,6.4957 22.4196,6.5247 22.2306,6.5687 L22.2306,9.2577 Z M20.4576,5.3907 C21.0246,5.2747 22.0566,5.1727 23.0736,5.1727 C24.3816,5.1727 25.2106,5.3477 25.8646,5.7977 C26.4746,6.1617 26.8816,6.8007 26.8816,7.6437 C26.8816,8.5447 26.3146,9.3587 25.2536,9.7517 L25.2536,9.7947 C26.2856,10.0567 27.2306,10.8707 27.2306,12.2077 C27.2306,13.0797 26.8526,13.7627 26.3006,14.2427 C25.6026,14.8387 24.4546,15.1437 22.6516,15.1437 C21.6636,15.1437 20.9226,15.0717 20.4576,15.0127 L20.4576,5.3907 Z"
          id="Fill-2"
          fill="#FFFFFF"
        />
      </g>
    </g>
  </SvgIcon>
);

export const ESSIcon = props => (
  <SvgIcon width="34px" height="34px" viewBox="0 0 34 34" {...props}>
    <defs />
    <g
      id="icn-ess"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icn-ess_34x34-@2x">
        <polygon id="Fill-1" fill="#0088CE" points="0 34 34 34 34 0 0 0" />
        <polygon
          id="Fill-2"
          fill="#FFFFFF"
          points="8.4796 10.6541 4.7876 10.6541 4.7876 13.5321 8.9156 13.5321 8.9156 15.0001 2.9996 15.0001 2.9996 5.2031 8.6976 5.2031 8.6976 6.6711 4.7876 6.6711 4.7876 9.2011 8.4796 9.2011"
        />
        <g
          id="Group-7"
          transform="translate(10.000000, 5.000000)"
          fill="#FFFFFF"
        >
          <path
            d="M0.4569,8.0523 C1.0239,8.3863 1.9109,8.6773 2.8259,8.6773 C3.9599,8.6773 4.5999,8.1393 4.5999,7.3403 C4.5999,6.5993 4.1049,6.1633 2.8699,5.7123 C1.2419,5.1313 0.2099,4.2733 0.2099,2.8633 C0.2099,1.2503 1.5469,0.0433 3.6839,0.0433 C4.7449,0.0433 5.5149,0.2763 6.0239,0.5383 L5.6019,1.9773 C5.2389,1.7883 4.5559,1.5113 3.6399,1.5113 C2.5059,1.5113 2.0269,2.1073 2.0269,2.6893 C2.0269,3.4453 2.5939,3.7933 3.9019,4.3023 C5.6019,4.9423 6.4159,5.7993 6.4159,7.2093 C6.4159,8.7933 5.2249,10.1603 2.7099,10.1603 C1.6639,10.1603 0.5879,9.8693 0.0499,9.5353 L0.4569,8.0523 Z"
            id="Fill-3"
          />
          <path
            d="M7.4884,8.0523 C8.0554,8.3863 8.9424,8.6773 9.8574,8.6773 C10.9914,8.6773 11.6314,8.1393 11.6314,7.3403 C11.6314,6.5993 11.1364,6.1633 9.9014,5.7123 C8.2734,5.1313 7.2414,4.2733 7.2414,2.8633 C7.2414,1.2503 8.5784,0.0433 10.7154,0.0433 C11.7764,0.0433 12.5464,0.2763 13.0554,0.5383 L12.6334,1.9773 C12.2704,1.7883 11.5874,1.5113 10.6714,1.5113 C9.5374,1.5113 9.0584,2.1073 9.0584,2.6893 C9.0584,3.4453 9.6254,3.7933 10.9334,4.3023 C12.6334,4.9423 13.4474,5.7993 13.4474,7.2093 C13.4474,8.7933 12.2564,10.1603 9.7414,10.1603 C8.6954,10.1603 7.6194,9.8693 7.0814,9.5353 L7.4884,8.0523 Z"
            id="Fill-5"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const EssentialsIcon = props => (
  <SvgIcon width="34px" height="34px" viewBox="0 0 34 34" {...props}>
    <defs />
    <g
      id="icn-essentials"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icn-essentials_34x34-@2x">
        <rect id="Rectangle-252" x="0" y="0" width="34" height="34" />
        <polygon
          id="Fill-1"
          fill="#939598"
          points="28 14 28 19 18.958525 19 19 29 15 29 15 33 34 33 34 14"
        />
        <polygon
          id="Fill-2"
          fill="#F99D2A"
          points="0 10 0 29 15.0413878 29 19 29 15.0413878 29 15 19 9 19 9 10"
        />
        <polygon
          id="Fill-3"
          fill="#0088CE"
          points="9 1 9 10 19 10 19 14 28 14 28 1"
        />
        <polygon
          id="Fill-4"
          fill="#006498"
          points="19 10 9 10 9 19 15 19 15 14 19 14"
        />
        <polygon id="Fill-5" fill="#006498" points="19 19 28 19 28 14 19 14" />
        <polygon id="Fill-6" fill="#B8731F" points="15 29 19 29 19 19 15 19" />
        <polygon id="Fill-7" fill="#003652" points="15 19 19 19 19 14 15 14" />
      </g>
    </g>
  </SvgIcon>
);

export const BVMIcon = props => (
  <SvgIcon width="34px" height="34px" viewBox="0 0 34 34" {...props}>
    <defs />
    <g
      id="icn-bvm"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icn-bvm_34x34-@2x">
        <polygon id="Fill-1" fill="#0088CE" points="0 34 34 34 34 0 0 0" />
        <path
          d="M19.1016,14.9756 L19.5976,16.4966 L19.1006,18.0276 L17.8026,18.9756 L16.1986,18.9756 L14.8996,18.0256 L14.4026,16.4966 L14.8986,14.9776 L16.1966,14.0396 L17.7976,14.0396 L16.9996,16.4936 L19.0956,14.9716 L19.1016,14.9756 Z M21.2106,13.4416 L22.2056,16.4956 L21.2106,19.5436 L18.6086,21.3426 L15.3916,21.3426 L12.7896,19.5426 L11.7946,16.4906 L12.7896,13.4406 L15.3916,11.6456 L18.5766,11.6456 L18.0046,13.4036 L15.9916,13.4036 L14.3576,14.5826 L13.7326,16.4966 L14.3566,18.4176 L15.9896,19.6126 L18.0096,19.6126 L19.6436,18.4196 L20.2676,16.4966 L19.6426,14.5806 L19.6386,14.5786 L21.2066,13.4396 L21.2106,13.4416 Z M23.2786,21.0536 L19.3976,23.8776 L14.6026,23.8776 L10.7216,21.0556 L9.2406,16.4966 L10.7216,11.9306 L14.6026,9.1056 L19.3976,9.1056 L19.4026,9.1086 L18.7836,11.0086 L15.1846,11.0086 L12.2476,13.0456 L11.1246,16.4906 L12.2476,19.9376 L15.1846,21.9796 L18.8156,21.9796 L21.7516,19.9386 L22.8746,16.4956 L21.7516,13.0466 L21.7496,13.0446 L23.2806,11.9346 L24.7596,16.4896 L23.2786,21.0536 Z M24.3076,11.1806 L19.7916,7.9996 L14.2076,7.9996 L9.6926,11.1826 L7.9666,16.4966 L9.6926,21.8036 L14.2076,24.9926 L19.7916,24.9926 L24.3076,21.8016 L26.0336,16.4896 L24.3076,11.1806 Z"
          id="Fill-2"
          fill="#FFFFFF"
        />
      </g>
    </g>
  </SvgIcon>
);

export const VRSIcon = props => (
  <SvgIcon width="34px" height="34px" viewBox="0 0 34 34" {...props}>
    <defs />
    <g
      id="icn-vrs"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icn-vrs_34x34-@2x">
        <polygon id="Fill-1" fill="#0088CE" points="0 34 34 34 34 0 0 0" />
        <path
          d="M18.9531,14.4512 L17.4821,13.3822 L15.4611,13.3822 L11.9991,15.9752 L13.8201,18.3962 L13.8261,18.4142 L13.8431,18.4262 L16.1151,21.4462 L14.8621,21.4462 L12.2571,19.5532 L11.2631,16.4912 L12.2571,13.4302 L14.8621,11.6212 L18.0811,11.6212 L20.0491,12.9682 L18.9531,14.4512 Z M16.4631,17.8242 L14.3501,15.0172 L14.3681,14.9642 L15.6681,14.0182 L17.2751,14.0182 L18.5751,14.9642 L16.4631,17.8242 Z M21.6811,16.4912 L20.6861,19.5532 L18.0811,21.4462 L16.8391,21.4462 L19.0331,18.4742 L19.1171,18.4142 L19.1471,18.3202 L21.3201,15.3802 L21.6811,16.4912 Z M24.2371,16.5072 L22.7551,21.0722 L18.8791,24.0002 L14.0781,24.0002 L10.1881,21.0722 L8.7051,16.5072 L10.1881,11.9422 L14.0711,9.0002 L18.8721,9.0002 L21.4941,11.0262 L20.4281,12.4712 L18.2881,11.0002 L14.6551,11.0002 L11.7161,13.0522 L10.5931,16.5072 L11.7161,19.9632 L14.6551,22.0002 L18.2881,22.0002 L21.2271,19.9632 L22.3501,16.5072 L21.7851,14.7652 L23.0961,12.9912 L24.2371,16.5072 Z M25.7021,9.4462 L23.7271,7.9872 L22.1631,10.1052 L19.2651,8.0002 L13.6791,8.0002 L9.1591,11.2842 L7.4321,16.5972 L9.1591,21.9102 L13.6791,25.0002 L19.2651,25.0002 L23.7841,21.9102 L25.5111,16.5972 L23.9551,11.8112 L25.7021,9.4462 Z"
          id="Fill-2"
          fill="#FFFFFF"
        />
      </g>
    </g>
  </SvgIcon>
);

export const AccountSettingsIcon = props => (
  <SvgIcon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
    <defs />
    <g
      id="[10]-User-Account-Menu"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="userSettings">
        <path
          d="M18.8278685,17.655737 C18.2246295,15.7176697 14.9535435,14.2890354 13.8534878,14.1144536 C13.4865917,14.0560497 13.47489,13.04254 13.47489,13.04254 C13.47489,13.04254 14.5638291,11.9705004 14.8018008,10.5266222 C15.4367926,10.5266222 15.8307766,8.99522483 15.1950732,8.45554396 C15.2207063,7.88816496 16.0145883,4 12,4 C7.98545913,4 8.77921467,7.88816496 8.80413615,8.45554396 C8.16927088,8.99522483 8.56248,10.5280709 9.19668113,10.5280709 C9.43471607,11.9705004 10.5243826,13.04254 10.5243826,13.04254 C10.5243826,13.04254 10.5133925,14.0560497 10.1464964,14.1144536 C9.0463932,14.2890354 5.77537054,15.7177327 5.17213151,17.655737 C8.18823242,21.4510498 15.1950732,21.7989502 18.8278685,17.655737 Z"
          id="user"
          fill="#0088CE"
        />
        <path
          d="M12,21.977535 C17.5228475,21.977535 22,17.5104404 22,12 C22,6.4895596 17.5228475,2.02246503 12,2.02246503 C6.4771525,2.02246503 2,6.4895596 2,12 C2,17.5104404 6.4771525,21.977535 12,21.977535 Z M12,24 C5.3785459,24 0,18.633537 0,12 C0,5.36646298 5.3785459,0 12,0 C18.6214541,0 24,5.36646298 24,12 C24,18.633537 18.6214541,24 12,24 Z"
          id="Oval"
          fill="#5F5F5F"
          fillRule="nonzero"
        />
      </g>
    </g>
  </SvgIcon>
);

export const RadioButtonUncheckIcon = props => (
  <SvgIcon {...props} viewBox="0 0 18 18">
    <defs>
      <circle id="path-1" cx="9" cy="9" r="9" />
    </defs>
    <g
      id="form/Radio-Button-Not-Selected"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Oval-28">
        <use fill="#FFFFFF" fillRule="evenodd" xlinkHref="#path-1" />
        <circle stroke="#DDDDDD" strokeWidth="1" cx="9" cy="9" r="8.5" />
      </g>
    </g>
  </SvgIcon>
);

export const RadioButtonCheckIcon = props => (
  <SvgIcon {...props} viewBox="0 0 18 18">
    <defs>
      <circle id="path-1" cx="9" cy="9" r="9" />
    </defs>
    <g
      id="form/Radio-Button-Selected"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group">
        <g id="Oval-28">
          <use fill="#FFFFFF" fillRule="evenodd" xlinkHref="#path-1" />
          <circle stroke="#DDDDDD" strokeWidth="1" cx="9" cy="9" r="8.5" />
        </g>
        <circle id="Oval-28" fill="#0077C8" cx="9" cy="9" r="5" />
      </g>
    </g>
  </SvgIcon>
);

export const WindowsIcon = props => (
  <svg {...props} viewBox="0 0 16 16">
    <defs />
    <g
      id="[11d]-SMB-Customer---Action-Menu"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-264.000000, -322.000000)"
    >
      <g id="icons/logo-windows" transform="translate(264.000000, 322.000000)">
        <g id="Page-1">
          <polygon
            id="Fill-1"
            fill="#FDBB2B"
            points="6.9516 9.00952 6.9516 14.76792 15.9996 15.99992 15.9996 9.00952"
          />
          <polygon
            id="Fill-2"
            fill="#69BB22"
            points="15.99984 0.00016 6.95184 1.25536 6.95184 8.00816 15.99984 8.00816"
          />
          <polygon
            id="Fill-3"
            fill="#1BA0EE"
            points="0 9.00952 0 13.82232 5.9456 14.63112 5.9456 9.00952"
          />
          <polygon
            id="Fill-4"
            fill="#F42F21"
            points="0 2.2192 0 8.008 5.9456 8.008 5.9456 1.3944"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const GreyMacIcon = props => (
  <svg version="1.1" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <g
      id="logos/color/apple"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M12.9961222,3.74044751 C14.3102056,2.00847669 16.1371285,2 16.1371285,2 C16.1371285,2 16.4088095,3.62837784 15.1034,5.19702462 C13.709478,6.87199137 12.1250607,6.59791188 12.1250607,6.59791188 C12.1250607,6.59791188 11.8275882,5.28060868 12.9961222,3.74044751 Z M12.2922025,7.73860103 C12.9682675,7.73860103 14.2229155,6.80931975 15.8560573,6.80931975 C18.6672285,6.80931975 19.7731074,8.80965324 19.7731074,8.80965324 C19.7731074,8.80965324 17.6101398,9.91549927 17.6101398,12.598863 C17.6101398,15.6259597 20.3045758,16.6691177 20.3045758,16.6691177 C20.3045758,16.6691177 18.4210432,21.9706273 15.8769534,21.9706273 C14.7084193,21.9706273 13.800034,21.1831498 12.5688119,21.1831498 C11.3141639,21.1831498 10.0690439,22 9.25814053,22 C6.93497019,22 4,16.9710585 4,12.9286652 C4,8.95142416 6.48429308,6.86504246 8.81439591,6.86504246 C10.3291927,6.86504246 11.5046922,7.73860103 12.2922025,7.73860103 Z"
        id="logo-apple"
        fill="#5f5f5f"
      />
    </g>
  </svg>
);

export const GreyWindowsIcon = props => (
  <SvgIcon version="1.1" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <defs />
    <path
      fill="currentColor"
      d="M3,12V6.75L9,5.43V11.91L3,12M20,3V11.75L10,11.9V5.21L20,3M3,13L9,13.09V19.9L3,18.75V13M20,13.25V22L10,20.09V13.1L20,13.25Z"
    />
  </SvgIcon>
);

export const ATPPolicyIcon = props => (
  <SvgIcon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <defs />
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icons/atp-policy">
        <g id="Group-35">
          <path
            d="M10,14.7049446 C11.0778723,14.3770212 12.0471066,13.7006151 12.7448953,12.756855 C13.4558223,11.7953252 13.75,10.6954209 13.75,9.19148936 L13.75,6.875 L10,6.25 C9.99955058,10.1618106 9.99955058,12.9801255 10,14.7049446 Z M5,6.25 L10,5 L15,6.25 L15,9.19148936 C15,10.7606383 14.7135417,12.1968085 13.75,13.5 C12.7864583,14.8031915 11.4322917,15.6542553 10,16 C8.56770833,15.6542553 7.21354167,14.8031915 6.25,13.5 C5.28645833,12.1968085 5,10.7606383 5,9.19148936 L5,6.25 Z"
            id="Shield-Copy"
            fill="#0088CE"
            fillRule="nonzero"
          />
          <path
            d="M18,9.9998 C18,8.8898 17.771,7.8318 17.36,6.8688 L19.098,5.8658 C19.672,7.1268 20,8.5238 20,9.9998 C20,15.1858 16.053,19.4478 11,19.9498 L11,17.9308 C14.94,17.4358 18,14.0718 18,9.9998 Z M2.6392,6.8689 C2.2282,7.8309 2.0002,8.8899 2.0002,9.9999 C2.0002,14.0719 5.0602,17.4359 9.0002,17.9309 L9.0002,19.9499 C3.9472,19.4479 0.0002,15.1849 0.0002,9.9999 C0.0002,8.5239 0.3282,7.1269 0.9022,5.8659 L2.6392,6.8689 Z M16.3447,5.1463 C14.8807,3.2383 12.5847,2.0003 9.9997,2.0003 C7.4147,2.0003 5.1187,3.2383 3.6557,5.1463 L1.9097,4.1383 C3.7277,1.6343 6.6697,0.0003 9.9997,0.0003 C13.3297,0.0003 16.2727,1.6343 18.0897,4.1383 L16.3447,5.1463 Z"
            id="Combined-Shape"
            fill="#5F5F5F"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const ATPPolicyWhiteIcon = props => (
  <SvgIcon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <defs />
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icons/atp-policy-white" fill="#FFFFFF" fillRule="nonzero">
        <path
          d="M10,14.7049446 C11.0778723,14.3770212 12.0471066,13.7006151 12.7448953,12.756855 C13.4558223,11.7953252 13.75,10.6954209 13.75,9.19148936 L13.75,6.875 L10,6.25 C9.99955058,10.1618106 9.99955058,12.9801255 10,14.7049446 Z M5,6.25 L10,5 L15,6.25 L15,9.19148936 C15,10.7606383 14.7135417,12.1968085 13.75,13.5 C12.7864583,14.8031915 11.4322917,15.6542553 10,16 C8.56770833,15.6542553 7.21354167,14.8031915 6.25,13.5 C5.28645833,12.1968085 5,10.7606383 5,9.19148936 L5,6.25 Z M18,9.9998 C18,8.8898 17.771,7.8318 17.36,6.8688 L19.098,5.8658 C19.672,7.1268 20,8.5238 20,9.9998 C20,15.1858 16.053,19.4478 11,19.9498 L11,17.9308 C14.94,17.4358 18,14.0718 18,9.9998 Z M2.6392,6.8689 C2.2282,7.8309 2.0002,8.8899 2.0002,9.9999 C2.0002,14.0719 5.0602,17.4359 9.0002,17.9309 L9.0002,19.9499 C3.9472,19.4479 0.0002,15.1849 0.0002,9.9999 C0.0002,8.5239 0.3282,7.1269 0.9022,5.8659 L2.6392,6.8689 Z M16.3447,5.1463 C14.8807,3.2383 12.5847,2.0003 9.9997,2.0003 C7.4147,2.0003 5.1187,3.2383 3.6557,5.1463 L1.9097,4.1383 C3.7277,1.6343 6.6697,0.0003 9.9997,0.0003 C13.3297,0.0003 16.2727,1.6343 18.0897,4.1383 L16.3447,5.1463 Z"
          id="Combined-Shape"
        />
      </g>
    </g>
  </SvgIcon>
);

export const QuarantineIcon = props => (
  <SvgIcon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <defs />
    <g
      id="[14]-SMB-Account---Quarantine"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="[14b]-SMB-Customer---Quarantine-Files"
        transform="translate(-243.000000, -127.000000)"
      >
        <g id="icons/quarantine" transform="translate(243.000000, 127.000000)">
          <g id="Group">
            <path
              d="M4.54862062,9.99724294 C4.41771038,11.2370861 4.71576063,12.5022297 5.39374041,13.5489681 C5.70205576,14.0250273 6.08452137,14.4525386 6.52320351,14.8120587 C6.74293707,14.9921811 6.97667948,15.1552754 7.22165311,15.299168 C7.34477395,15.3714464 7.47079317,15.4389545 7.5992277,15.5015113 C7.66365631,15.5329104 7.72880952,15.5629811 7.7943854,15.5917234 C7.90917339,15.6420828 7.94606738,15.4815849 7.99678906,15.386844 C8.16610285,15.0711016 8.28874062,14.7307833 8.35993212,14.379596 C8.38034156,14.2791792 8.42913099,14.2216946 8.32629882,14.1740525 C8.26180983,14.1442233 8.19810582,14.1125222 8.13536793,14.0793116 C8.01037522,14.0128904 7.88888472,13.9398874 7.77168141,13.8606649 C7.28505521,13.5314571 6.87348501,13.0941034 6.57477055,12.5881546 C6.28088673,12.0902972 6.09907366,11.529098 6.04503092,10.9535277 C6.03053901,10.7988266 6.02474225,10.6431594 6.02866714,10.487794 C6.03090131,10.3981857 6.03645654,10.3084567 6.04448747,10.2190899 C5.95542262,10.1861208 5.86508973,10.1566539 5.77373032,10.1306289 C5.37653127,10.0178335 4.9606135,9.97254632 4.54862062,9.99724294"
              id="path6-path"
              fill="#0088CE"
            />
            <path
              d="M7.67706133,7.36243287 C8.69475559,6.62956499 10.0327814,6.42202878 11.2246805,6.81391414 C11.5070312,6.90672273 11.7786337,7.03171544 12.0330271,7.18539005 C12.1426825,7.25169053 12.2600669,7.39860225 12.3658579,7.30820898 C12.4942924,7.19861392 12.6151791,7.08008219 12.7271895,6.95382143 C12.933518,6.72140746 13.1102589,6.46284766 13.2516758,6.18623336 C12.9904591,5.99186064 12.711973,5.82079574 12.4203233,5.67593704 C11.2823462,5.1104507 9.95663851,4.96160672 8.72059949,5.25506787 C8.13331491,5.39461287 7.57048542,5.63270284 7.06091369,5.95611393 C6.94666915,6.02863386 6.83514184,6.10544097 6.72657329,6.18629374 C6.80380309,6.33749265 6.89166028,6.48337786 6.98911836,6.6224398 C7.18294764,6.89911448 7.4150597,7.14891875 7.67706133,7.36243287"
              id="path6-path"
              fill="#0088CE"
            />
            <path
              d="M11.6183169,14.189269 C11.6754996,14.5426904 11.7847324,14.8874166 11.9411242,15.2093182 C11.9947443,15.3193359 12.1021051,15.6282551 12.2279432,15.5717366 C12.3589742,15.5128029 12.4877711,15.4488573 12.6137903,15.3798396 C13.1344725,15.0945302 13.6078748,14.7242015 14.0106291,14.2879347 C14.8152923,13.4161256 15.3213014,12.2901044 15.4350025,11.1088931 C15.4664017,10.7827044 15.4686358,10.4536777 15.4415843,10.1270059 C15.4317418,10.0079307 15.4705077,9.9492385 15.3339818,9.9456759 C15.2441924,9.94326059 15.1541614,9.94422671 15.064372,9.94839314 C14.8855781,9.95678637 14.707388,9.9782827 14.5318547,10.0125802 C14.3565026,10.0468173 14.1835055,10.093916 14.015037,10.1532725 C13.8848514,10.1992239 13.939498,10.2572519 13.9458382,10.3800105 C13.9503669,10.4716718 13.9518765,10.5632123 13.9500046,10.6549341 C13.9439059,10.9774998 13.8987395,11.2992201 13.8149279,11.6107358 C13.5090883,12.7456334 12.6890274,13.7054204 11.6183169,14.189269"
              id="path6-path"
              fill="#0088CE"
            />
            <path
              d="M1.35092067,11.6693676 C2.60416883,9.46532953 5.69849316,9.02054871 7.53220263,10.7673671 C7.58847954,10.8210475 8.11821917,11.4269905 8.09901739,11.4380405 C8.22938418,11.362743 8.35969059,11.2875058 8.49017815,11.2122687 C8.63642566,11.1279137 8.78267317,11.0433776 8.92898106,10.9590226 C9.00971306,10.912407 8.94105765,10.8459857 8.92620344,10.7614496 C8.89534775,10.5865202 8.9093566,10.4041637 8.96575427,10.2357556 C9.05131692,9.98057725 9.2337942,9.76295709 9.46952924,9.6333149 C9.49821114,9.61749456 9.78853237,9.51091866 9.78853237,9.51556814 C9.78853237,9.45772128 9.78853237,9.39987441 9.78853237,9.34208792 C9.78853237,9.15212316 9.78853237,8.96233954 9.78853237,8.77237478 C9.78853237,8.70160596 9.78853237,8.63089752 9.78853237,8.5601287 C9.78853237,8.45663233 9.62127159,8.50016843 9.53818465,8.49074869 C7.359447,8.24372204 5.78097628,6.20277829 6.05475258,4.0383514 C6.17823571,3.06268367 6.67947459,2.15222953 7.42991391,1.51814816 C7.8896697,1.12970464 8.43692039,0.848078551 9.02082353,0.701710277 C9.16978827,0.66433323 9.11055259,0.508001769 9.11055259,0.364471494 C9.11055259,0.242980996 9.11055259,0.121550881 9.11055259,0.000120765903 C6.82336716,0.336333039 4.88610094,2.02669338 4.23970144,4.24582722 C4.07213875,4.82133713 3.99273517,5.42166443 4.00239645,6.02084445 C4.00855551,6.40367237 4.05112549,6.78583606 4.12986486,7.16057266 C4.15921097,7.30035919 4.09906955,7.26763163 3.98065858,7.3098997 C3.89600169,7.34003079 3.812009,7.37209414 3.72874091,7.40596897 C3.53183211,7.48621792 3.33921049,7.57697349 3.15190258,7.67757149 C2.09719357,8.24426549 1.2258072,9.12350164 0.673484342,10.1861208 C-0.12061185,11.7143529 -0.220002188,13.5515646 0.415347225,15.1534639 C0.583574127,15.0563681 0.75180103,14.9591516 0.920088315,14.8621162 C1.04194111,14.7918304 0.993574367,14.7889924 0.953842385,14.6360424 C0.885247352,14.3722897 0.844186945,14.1014118 0.831446142,13.8293262 C0.78495127,13.0846836 0.981437393,12.3146802 1.35092067,11.6693676"
              id="path6-path"
              fill="#5F5F5F"
            />
            <path
              d="M17.355905,16.9305946 C16.3181636,17.5622606 15.076992,17.7451002 13.9161902,17.3436139 C12.7556902,16.9439996 11.8320122,16.0059504 11.4458028,14.841586 C11.2291488,14.1878801 11.1853108,13.4786824 11.3218367,12.8036614 C11.3935112,12.4500588 11.5141564,12.106661 11.6786999,11.7856652 C11.6501991,11.7167682 11.3920016,11.6200951 11.329143,11.583805 C11.1764345,11.4955251 11.0234845,11.4073056 10.870776,11.3190861 C10.8001883,11.2783276 10.8216847,11.2697533 10.75472,11.3374425 C10.6292442,11.4641864 10.4727316,11.5592291 10.3020894,11.6110981 C9.99920849,11.7031217 9.66360004,11.6550569 9.39894157,11.4812747 C9.3641006,11.4583896 9.17618886,11.2793541 9.16073082,11.2882304 C9.10173668,11.3222864 9.04280292,11.3564028 8.98380878,11.3903984 C8.8190237,11.4855015 8.65417825,11.5806651 8.48939317,11.675889 C8.43486737,11.7073485 8.38028118,11.7388684 8.32575537,11.7703279 C8.26990114,11.802512 8.39899989,11.980521 8.4220058,12.0323899 C8.72150524,12.7063241 8.82596774,13.4594202 8.72307519,14.1896313 C8.56946097,15.2796643 7.95446061,16.2869123 7.04334225,16.907951 C6.06073049,17.5776583 4.8182305,17.7812092 3.67463779,17.4451177 C3.09949018,17.275502 2.56522182,16.9766064 2.12201096,16.572584 C2.08463391,16.5385281 1.90076783,16.3248328 1.86797988,16.3438534 C1.80916689,16.3777886 1.75041428,16.4117239 1.69166167,16.4456591 C1.55912109,16.522285 1.42645974,16.5986695 1.29385878,16.6752351 C2.80663286,18.5861743 5.41843704,19.3958493 7.74704517,18.6763261 C8.37164642,18.4833422 8.96406355,18.1869222 9.49398433,17.8040943 C9.63389163,17.7030133 9.76951174,17.5959543 9.90018045,17.4832193 C9.988883,17.4066537 9.99268713,17.3399306 10.0931644,17.4269424 C10.1589818,17.4839439 10.2260672,17.539617 10.2943604,17.5938409 C10.5855269,17.8248057 10.8983106,18.0285981 11.226975,18.2022595 C12.3017312,18.7701008 13.5390986,18.9982276 14.74555,18.8500478 C16.2966672,18.6596 17.7404236,17.854816 18.7108984,16.628861 C18.5426111,16.5317652 18.3744446,16.434609 18.2061573,16.3375132 C18.0724091,16.2603438 18.0539319,16.3648667 17.9442161,16.469148 C17.7633691,16.6408772 17.5660376,16.7956387 17.355905,16.9305946"
              id="path6-path"
              fill="#5F5F5F"
            />
            <path
              d="M17.0144394,7.72086606 C16.7738737,7.58198528 16.5236468,7.4597098 16.2661135,7.35524729 C16.1259043,7.29842694 15.9834005,7.24679951 15.8393268,7.20066694 C15.8714505,7.05278909 15.8980794,6.9036432 15.9189115,6.75377272 C15.9902841,6.24142338 15.9952355,5.71977506 15.9338865,5.20609729 C15.8300882,4.33682433 15.5330041,3.49442177 15.0687195,2.75225492 C14.1457057,1.2767975 12.5906032,0.253306481 10.8675757,0 C10.8675757,0.137431597 10.8675757,0.27498396 10.8675757,0.41247594 C10.8675757,0.489162288 10.8675757,0.565848636 10.8675757,0.642534985 C10.8675757,0.725561543 11.1447335,0.752733871 11.2219632,0.777913561 C11.8141389,0.971320154 12.3584912,1.3065663 12.7979583,1.74820721 C13.6440442,2.59858031 14.0675702,3.80738661 13.9307424,4.9995876 C13.8077424,6.08364272 13.2281264,7.08267865 12.3532378,7.73390878 C11.8173391,8.13273818 11.1827143,8.39232448 10.5204945,8.48126857 C10.4786491,8.48688418 10.1895959,8.50216107 10.1895959,8.52444238 C10.1895959,8.57908895 10.1895959,8.63367514 10.1895959,8.68826133 C10.1895959,8.89259723 10.1895959,9.09693314 10.1895959,9.30126905 C10.1895959,9.36436923 10.1895959,9.4275298 10.1895959,9.49062998 C10.1895959,9.551496 10.3345754,9.55523974 10.3868066,9.57589071 C10.6580469,9.68343275 10.8786862,9.9017775 10.9889454,10.172112 C11.0414182,10.3008484 11.0682283,10.4394877 11.0682283,10.5784289 C11.0682283,10.6244407 11.0071207,10.9345071 11.0179896,10.9408473 C11.1597688,11.0226058 11.3014876,11.1044851 11.4432668,11.186304 C11.5805172,11.2655868 11.717828,11.3448697 11.8550785,11.4240921 C11.8820093,11.4397313 12.3111509,10.8821551 12.3834293,10.8087898 C12.8222926,10.3624994 13.3692414,10.0215169 13.9644965,9.82732532 C16.2021075,9.09705391 18.6156141,10.501501 19.0985569,12.804869 C19.2242742,13.4236131 19.2003626,14.0703145 19.0271843,14.677767 C18.9856408,14.8230484 19.1078559,14.828664 19.2323656,14.9005801 C19.3515011,14.9693563 19.4704555,15.0380721 19.5895911,15.1068483 C20.6700836,12.3824299 19.5504026,9.18497148 17.0144394,7.72086606"
              id="path6-path"
              fill="#5F5F5F"
            />
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const QuarantineWhiteIcon = props => (
  <SvgIcon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <defs />
    <g
      id="icons/quarantine-white"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M4.54862062,9.99724294 C4.41771038,11.2370861 4.71576063,12.5022297 5.39374041,13.5489681 C5.70205576,14.0250273 6.08452137,14.4525386 6.52320351,14.8120587 C6.74293707,14.9921811 6.97667948,15.1552754 7.22165311,15.299168 C7.34477395,15.3714464 7.47079317,15.4389545 7.5992277,15.5015113 C7.66365631,15.5329104 7.72880952,15.5629811 7.7943854,15.5917234 C7.90917339,15.6420828 7.94606738,15.4815849 7.99678906,15.386844 C8.16610285,15.0711016 8.28874062,14.7307833 8.35993212,14.379596 C8.38034156,14.2791792 8.42913099,14.2216946 8.32629882,14.1740525 C8.26180983,14.1442233 8.19810582,14.1125222 8.13536793,14.0793116 C8.01037522,14.0128904 7.88888472,13.9398874 7.77168141,13.8606649 C7.28505521,13.5314571 6.87348501,13.0941034 6.57477055,12.5881546 C6.28088673,12.0902972 6.09907366,11.529098 6.04503092,10.9535277 C6.03053901,10.7988266 6.02474225,10.6431594 6.02866714,10.487794 C6.03090131,10.3981857 6.03645654,10.3084567 6.04448747,10.2190899 C5.95542262,10.1861208 5.86508973,10.1566539 5.77373032,10.1306289 C5.37653127,10.0178335 4.9606135,9.97254632 4.54862062,9.99724294"
        id="path6-path"
        fill="#FFFFFF"
      />
      <path
        d="M7.67706133,7.36243287 C8.69475559,6.62956499 10.0327814,6.42202878 11.2246805,6.81391414 C11.5070312,6.90672273 11.7786337,7.03171544 12.0330271,7.18539005 C12.1426825,7.25169053 12.2600669,7.39860225 12.3658579,7.30820898 C12.4942924,7.19861392 12.6151791,7.08008219 12.7271895,6.95382143 C12.933518,6.72140746 13.1102589,6.46284766 13.2516758,6.18623336 C12.9904591,5.99186064 12.711973,5.82079574 12.4203233,5.67593704 C11.2823462,5.1104507 9.95663851,4.96160672 8.72059949,5.25506787 C8.13331491,5.39461287 7.57048542,5.63270284 7.06091369,5.95611393 C6.94666915,6.02863386 6.83514184,6.10544097 6.72657329,6.18629374 C6.80380309,6.33749265 6.89166028,6.48337786 6.98911836,6.6224398 C7.18294764,6.89911448 7.4150597,7.14891875 7.67706133,7.36243287"
        id="path6-path"
        fill="#FFFFFF"
      />
      <path
        d="M11.6183169,14.189269 C11.6754996,14.5426904 11.7847324,14.8874166 11.9411242,15.2093182 C11.9947443,15.3193359 12.1021051,15.6282551 12.2279432,15.5717366 C12.3589742,15.5128029 12.4877711,15.4488573 12.6137903,15.3798396 C13.1344725,15.0945302 13.6078748,14.7242015 14.0106291,14.2879347 C14.8152923,13.4161256 15.3213014,12.2901044 15.4350025,11.1088931 C15.4664017,10.7827044 15.4686358,10.4536777 15.4415843,10.1270059 C15.4317418,10.0079307 15.4705077,9.9492385 15.3339818,9.9456759 C15.2441924,9.94326059 15.1541614,9.94422671 15.064372,9.94839314 C14.8855781,9.95678637 14.707388,9.9782827 14.5318547,10.0125802 C14.3565026,10.0468173 14.1835055,10.093916 14.015037,10.1532725 C13.8848514,10.1992239 13.939498,10.2572519 13.9458382,10.3800105 C13.9503669,10.4716718 13.9518765,10.5632123 13.9500046,10.6549341 C13.9439059,10.9774998 13.8987395,11.2992201 13.8149279,11.6107358 C13.5090883,12.7456334 12.6890274,13.7054204 11.6183169,14.189269"
        id="path6-path"
        fill="#FFFFFF"
      />
      <path
        d="M1.35092067,11.6693676 C2.60416883,9.46532953 5.69849316,9.02054871 7.53220263,10.7673671 C7.58847954,10.8210475 8.11821917,11.4269905 8.09901739,11.4380405 C8.22938418,11.362743 8.35969059,11.2875058 8.49017815,11.2122687 C8.63642566,11.1279137 8.78267317,11.0433776 8.92898106,10.9590226 C9.00971306,10.912407 8.94105765,10.8459857 8.92620344,10.7614496 C8.89534775,10.5865202 8.9093566,10.4041637 8.96575427,10.2357556 C9.05131692,9.98057725 9.2337942,9.76295709 9.46952924,9.6333149 C9.49821114,9.61749456 9.78853237,9.51091866 9.78853237,9.51556814 C9.78853237,9.45772128 9.78853237,9.39987441 9.78853237,9.34208792 C9.78853237,9.15212316 9.78853237,8.96233954 9.78853237,8.77237478 C9.78853237,8.70160596 9.78853237,8.63089752 9.78853237,8.5601287 C9.78853237,8.45663233 9.62127159,8.50016843 9.53818465,8.49074869 C7.359447,8.24372204 5.78097628,6.20277829 6.05475258,4.0383514 C6.17823571,3.06268367 6.67947459,2.15222953 7.42991391,1.51814816 C7.8896697,1.12970464 8.43692039,0.848078551 9.02082353,0.701710277 C9.16978827,0.66433323 9.11055259,0.508001769 9.11055259,0.364471494 C9.11055259,0.242980996 9.11055259,0.121550881 9.11055259,0.000120765903 C6.82336716,0.336333039 4.88610094,2.02669338 4.23970144,4.24582722 C4.07213875,4.82133713 3.99273517,5.42166443 4.00239645,6.02084445 C4.00855551,6.40367237 4.05112549,6.78583606 4.12986486,7.16057266 C4.15921097,7.30035919 4.09906955,7.26763163 3.98065858,7.3098997 C3.89600169,7.34003079 3.812009,7.37209414 3.72874091,7.40596897 C3.53183211,7.48621792 3.33921049,7.57697349 3.15190258,7.67757149 C2.09719357,8.24426549 1.2258072,9.12350164 0.673484342,10.1861208 C-0.12061185,11.7143529 -0.220002188,13.5515646 0.415347225,15.1534639 C0.583574127,15.0563681 0.75180103,14.9591516 0.920088315,14.8621162 C1.04194111,14.7918304 0.993574367,14.7889924 0.953842385,14.6360424 C0.885247352,14.3722897 0.844186945,14.1014118 0.831446142,13.8293262 C0.78495127,13.0846836 0.981437393,12.3146802 1.35092067,11.6693676"
        id="path6-path"
        fill="#FFFFFF"
      />
      <path
        d="M17.355905,16.9305946 C16.3181636,17.5622606 15.076992,17.7451002 13.9161902,17.3436139 C12.7556902,16.9439996 11.8320122,16.0059504 11.4458028,14.841586 C11.2291488,14.1878801 11.1853108,13.4786824 11.3218367,12.8036614 C11.3935112,12.4500588 11.5141564,12.106661 11.6786999,11.7856652 C11.6501991,11.7167682 11.3920016,11.6200951 11.329143,11.583805 C11.1764345,11.4955251 11.0234845,11.4073056 10.870776,11.3190861 C10.8001883,11.2783276 10.8216847,11.2697533 10.75472,11.3374425 C10.6292442,11.4641864 10.4727316,11.5592291 10.3020894,11.6110981 C9.99920849,11.7031217 9.66360004,11.6550569 9.39894157,11.4812747 C9.3641006,11.4583896 9.17618886,11.2793541 9.16073082,11.2882304 C9.10173668,11.3222864 9.04280292,11.3564028 8.98380878,11.3903984 C8.8190237,11.4855015 8.65417825,11.5806651 8.48939317,11.675889 C8.43486737,11.7073485 8.38028118,11.7388684 8.32575537,11.7703279 C8.26990114,11.802512 8.39899989,11.980521 8.4220058,12.0323899 C8.72150524,12.7063241 8.82596774,13.4594202 8.72307519,14.1896313 C8.56946097,15.2796643 7.95446061,16.2869123 7.04334225,16.907951 C6.06073049,17.5776583 4.8182305,17.7812092 3.67463779,17.4451177 C3.09949018,17.275502 2.56522182,16.9766064 2.12201096,16.572584 C2.08463391,16.5385281 1.90076783,16.3248328 1.86797988,16.3438534 C1.80916689,16.3777886 1.75041428,16.4117239 1.69166167,16.4456591 C1.55912109,16.522285 1.42645974,16.5986695 1.29385878,16.6752351 C2.80663286,18.5861743 5.41843704,19.3958493 7.74704517,18.6763261 C8.37164642,18.4833422 8.96406355,18.1869222 9.49398433,17.8040943 C9.63389163,17.7030133 9.76951174,17.5959543 9.90018045,17.4832193 C9.988883,17.4066537 9.99268713,17.3399306 10.0931644,17.4269424 C10.1589818,17.4839439 10.2260672,17.539617 10.2943604,17.5938409 C10.5855269,17.8248057 10.8983106,18.0285981 11.226975,18.2022595 C12.3017312,18.7701008 13.5390986,18.9982276 14.74555,18.8500478 C16.2966672,18.6596 17.7404236,17.854816 18.7108984,16.628861 C18.5426111,16.5317652 18.3744446,16.434609 18.2061573,16.3375132 C18.0724091,16.2603438 18.0539319,16.3648667 17.9442161,16.469148 C17.7633691,16.6408772 17.5660376,16.7956387 17.355905,16.9305946"
        id="path6-path"
        fill="#FFFFFF"
      />
      <path
        d="M17.0144394,7.72086606 C16.7738737,7.58198528 16.5236468,7.4597098 16.2661135,7.35524729 C16.1259043,7.29842694 15.9834005,7.24679951 15.8393268,7.20066694 C15.8714505,7.05278909 15.8980794,6.9036432 15.9189115,6.75377272 C15.9902841,6.24142338 15.9952355,5.71977506 15.9338865,5.20609729 C15.8300882,4.33682433 15.5330041,3.49442177 15.0687195,2.75225492 C14.1457057,1.2767975 12.5906032,0.253306481 10.8675757,0 C10.8675757,0.137431597 10.8675757,0.27498396 10.8675757,0.41247594 C10.8675757,0.489162288 10.8675757,0.565848636 10.8675757,0.642534985 C10.8675757,0.725561543 11.1447335,0.752733871 11.2219632,0.777913561 C11.8141389,0.971320154 12.3584912,1.3065663 12.7979583,1.74820721 C13.6440442,2.59858031 14.0675702,3.80738661 13.9307424,4.9995876 C13.8077424,6.08364272 13.2281264,7.08267865 12.3532378,7.73390878 C11.8173391,8.13273818 11.1827143,8.39232448 10.5204945,8.48126857 C10.4786491,8.48688418 10.1895959,8.50216107 10.1895959,8.52444238 C10.1895959,8.57908895 10.1895959,8.63367514 10.1895959,8.68826133 C10.1895959,8.89259723 10.1895959,9.09693314 10.1895959,9.30126905 C10.1895959,9.36436923 10.1895959,9.4275298 10.1895959,9.49062998 C10.1895959,9.551496 10.3345754,9.55523974 10.3868066,9.57589071 C10.6580469,9.68343275 10.8786862,9.9017775 10.9889454,10.172112 C11.0414182,10.3008484 11.0682283,10.4394877 11.0682283,10.5784289 C11.0682283,10.6244407 11.0071207,10.9345071 11.0179896,10.9408473 C11.1597688,11.0226058 11.3014876,11.1044851 11.4432668,11.186304 C11.5805172,11.2655868 11.717828,11.3448697 11.8550785,11.4240921 C11.8820093,11.4397313 12.3111509,10.8821551 12.3834293,10.8087898 C12.8222926,10.3624994 13.3692414,10.0215169 13.9644965,9.82732532 C16.2021075,9.09705391 18.6156141,10.501501 19.0985569,12.804869 C19.2242742,13.4236131 19.2003626,14.0703145 19.0271843,14.677767 C18.9856408,14.8230484 19.1078559,14.828664 19.2323656,14.9005801 C19.3515011,14.9693563 19.4704555,15.0380721 19.5895911,15.1068483 C20.6700836,12.3824299 19.5504026,9.18497148 17.0144394,7.72086606"
        id="path6-path"
        fill="#FFFFFF"
      />
    </g>
  </SvgIcon>
);

export const AuditLogIcon = props => (
  <SvgIcon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <defs />
    <g
      id="icons/audit-log"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M19,15 L19,18 C19,19.1 18.1,20 17,20 L13,20 L13,18 L5,18 L5,20 L3,20 C1.9,20 1,19.1 1,18 L1,4 C1,2.9 1.9,2 3,2 L7.2,2 C7.6,0.8 8.7,0 10,0 C11.3,0 12.4,0.8 12.8,2 L17,2 C18.1,2 19,2.9 19,4 L19,7 L17,7 L17,15 L19,15 Z M10,2 C10.6,2 11,2.4 11,3 C11,3.6 10.6,4 10,4 C9.4,4 9,3.6 9,3 C9,2.4 9.4,2 10,2 L10,2 Z M17,18 L3,18 L3,4 L5,4 L5,7 L15,7 L15,4 L17,4 L17,18 Z M5,8 L7,8 L7,10 L5,10 L5,8 Z M8,8 L15,8 L15,10 L8,10 L8,8 Z M5,11 L7,11 L7,13 L5,13 L5,11 Z M8,11 L12,11 L12,13 L8,13 L8,11 Z"
        id="log"
        fill="#5F5F5F"
      />
      <polygon
        id="checkmark"
        fill="#0088CE"
        points="6.35172414 14.3070175 5 15.6578947 9.34482759 20 19 10.3508772 17.6482759 9 9.34482759 17.2982456"
      />
    </g>
  </SvgIcon>
);

export const AuditLogWhiteIcon = props => (
  <SvgIcon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <defs />
    <g
      id="icons/audit-log-white"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M19,15 L19,18 C19,19.1 18.1,20 17,20 L13,20 L13,18 L5,18 L5,20 L3,20 C1.9,20 1,19.1 1,18 L1,4 C1,2.9 1.9,2 3,2 L7.2,2 C7.6,0.8 8.7,0 10,0 C11.3,0 12.4,0.8 12.8,2 L17,2 C18.1,2 19,2.9 19,4 L19,7 L17,7 L17,15 L19,15 Z M10,2 C10.6,2 11,2.4 11,3 C11,3.6 10.6,4 10,4 C9.4,4 9,3.6 9,3 C9,2.4 9.4,2 10,2 L10,2 Z M17,18 L3,18 L3,4 L5,4 L5,7 L15,7 L15,4 L17,4 L17,18 Z M5,8 L7,8 L7,10 L5,10 L5,8 Z M8,8 L15,8 L15,10 L8,10 L8,8 Z M5,11 L7,11 L7,13 L5,13 L5,11 Z M8,11 L12,11 L12,13 L8,13 L8,11 Z M6.35172414,14.3070175 L9.34482759,17.2982456 L17.6482759,9 L19,10.3508772 L9.34482759,20 L5,15.6578947 L6.35172414,14.3070175 Z"
        id="Shape"
        fill="#FFFFFF"
      />
    </g>
  </SvgIcon>
);

export const DeviceIcon = props => (
  <SvgIcon width="20px" height="20px" viewBox="0 0 20 20">
    <defs />
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icons/device-list-3">
        <path
          d="M1,9 L6,9 L6,8 L1,8 L1,9 Z M2,15.5 C2,14.6705 2.6705,14 3.5,14 C4.3295,14 5,14.6705 5,15.5 C5,16.3295 4.3295,17 3.5,17 C2.6705,17 2,16.3295 2,15.5 Z M1,6 C0.447,6 0,6.448 0,7 L0,18 C0,18.553 0.447,19 1,19 L6,19 C6.553,19 7,18.553 7,18 L7,7 C7,6.448 6.553,6 6,6 L1,6 Z"
          id="Page-1"
          fill="#0088CE"
        />
        <path
          d="M1,1 C0.447,1 0,1.448 0,2 L0,5 L2,5 L2,3 L18,3 L18,12 L9,12 L9,18 L8,18 L8,19 L14,19 L14,18 L13,18 L13,14 L19,14 C19.553,14 20,13.553 20,13 L20,2 C20,1.448 19.553,1 19,1 L1,1 Z"
          id="Page-1"
          fill="#5F5F5F"
        />
      </g>
    </g>
  </SvgIcon>
);

export const RestoreIcon = props => (
  <SvgIcon width="20px" height="20px" viewBox="0 0 20 20">
    <defs />
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icons/icn-restore" fill={props.color || '#5F5F5F'}>
        <path
          d="M3,5 L8,0 L8,10 L3,5 Z M0,20 L0,18 L12,18 C15.3137085,18 18,15.3137085 18,12 C18,8.6862915 15.3137085,6 12,6 L8,6 L8,4 L12,4 C16.418278,4 20,7.581722 20,12 C20,16.418278 16.418278,20 12,20 L0,20 Z"
          id="Combined-Shape"
        />
      </g>
    </g>
  </SvgIcon>
);

export const DeployIcon = props => (
  <SvgIcon width="20px" height="20px" viewBox="0 0 20 20">
    <defs />
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icons/deploy">
        <path
          d="M2,0 C0.9,0 0,0.9 0,2 L0,6 L2,6 L2,2 L18,2 L18,16 L2,16 L2,12 L0,12 L0,16 C0,17.1 0.9,18 2,18 L5,18 L5,20 L15,20 L15,18 L18,18 C19.1,18 20,17.1 20,16 L20,2 C20,0.9 19.1,0 18,0 L2,0 Z"
          id="Page-1"
          fill="#5F5F5F"
        />
        <polygon
          id="Page-1"
          fill="#0077C8"
          points="8.5 4 7.1 5.399 9.701 8 0 8 0 10 9.701 10 7.1 12.6 8.5 14 13.5 8.999"
        />
      </g>
    </g>
  </SvgIcon>
);

export const ReportIcon = props => (
  <svg width="24px" height="24px" viewBox="0 0 24 24">
    <g
      id="icons/component/color/reports"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M2,2 L4,2 L4,20 L22,20 L22,22 L2,22 L2,2 Z M8,12.3562 L5,13.8772 L5,7.0002 L8,7.0002 L8,12.3562 Z M5,18.118 L8,16.618 L8,19 L5,19 L5,18.118 Z M9.0034,11.847 L9.0004,11.848 L9.0004,3 L12.0004,3 L12.0004,11.586 L10.8094,12.777 L9.0034,11.847 Z M11.1973,17.2166 L12.0003,16.4136 L12.0003,18.9996 L9.0003,18.9996 L9.0003,16.1176 L11.1973,17.2166 Z M14.873,8.7132 L13,10.5862 L13,8.0002 L16,8.0002 L16,9.4642 L14.873,8.7132 Z M15.127,13.2869 L16,13.8689 L16,18.9999 L13,18.9999 L13,15.4139 L15.127,13.2869 Z M17.873,10.7132 L17,10.1312 L17,6.0002 L20,6.0002 L20,8.5862 L17.873,10.7132 Z M18.1299,15.2879 L19.9999,13.4039 L19.9999,18.9999 L16.9999,18.9999 L16.9999,14.5349 L18.1299,15.2879 Z"
        id="Combined-Shape"
        fill="#5F5F5F"
      />
      <polygon
        id="Fill-10"
        fill="#0088CE"
        fill-rule="nonzero"
        points="18.0002 11.9999 14.9992 9.9999 11.0002 13.9999 9.0002 12.9699 4.9992 14.9999 4.9992 16.9989 9.0002 14.9999 11.0002 15.9999 14.9992 11.9999 18.0002 13.9999 22.0002 9.9699 21.0002 8.9999"
      />
    </g>
  </svg>
);

export const LogIcon = props => (
  <SvgIcon width="20px" height="20px" viewBox="0 0 20 20">
    <defs />
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icons/icn-logs">
        <path
          d="M0,5 L20,5 L20,18.0081158 C20,19.1082031 19.1017876,20 18.0092049,20 L1.99079514,20 C0.891309342,20 0,19.1066027 0,18.0081158 L0,5 Z M12,7 L12,9 L18,9 L18,7 L12,7 Z M5,7 L5,9 L11,9 L11,7 L5,7 Z M2,7 L2,9 L4,9 L4,7 L2,7 Z M12,10 L12,14 L18,14 L18,10 L12,10 Z M5,10 L5,14 L11,14 L11,10 L5,10 Z M2,10 L2,14 L4,14 L4,10 L2,10 Z M12,15 L12,18 L18,18 L18,15 L12,15 Z M5,15 L5,18 L11,18 L11,15 L5,15 Z M2,15 L2,18 L4,18 L4,15 L2,15 Z"
          id="icn-table"
          fill="#5F5F5F"
        />
        <path
          d="M0,1.0093689 C0,0.451909848 0.455305576,0 0.99180311,0 L19.0081969,0 C19.5559546,0 20,0.443353176 20,1.0093689 L20,4 L0,4 L0,1.0093689 Z"
          id="icn-table"
          fill="#0077C8"
        />
      </g>
    </g>
  </SvgIcon>
);

export const BellIcon = props => (
  <svg width="24px" height="24px" viewBox="0 0 24 24">
    <g
      id="icons/component/color/alerts"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="M12,22 C10.8954305,22 10,21.1045695 10,20 C10.4298503,20 13.7295736,20 14,20 C14,21.1045695 13.1045695,22 12,22 Z M18.5615684,8 C18.3209657,6.36327504 17.3634154,4.9554849 16,4.10254372 L16.3848023,3.40063593 C18.0025924,4.38950715 19.1270253,6.05961844 19.3757291,8 L18.5615684,8 Z M16.7679844,2.7027027 L17.154407,2 C19.2760855,3.26311606 20.7399546,5.45468998 21,8 L20.1882696,8 C19.9322748,5.76073132 18.6369086,3.82988871 16.7679844,2.7027027 Z M5.43843163,8 L4.6242709,8 C4.87297472,6.05961844 5.99740765,4.38950715 7.61519767,3.40063593 L8,4.10254372 C6.63658458,4.9554849 5.67903435,6.36327504 5.43843163,8 Z M7.23201555,2.7027027 C5.36309138,3.82988871 4.06772521,5.76073132 3.8117304,8 L3,8 C3.26004537,5.45468998 4.72391445,3.26311606 6.845593,2 L7.23201555,2.7027027 Z"
        id="Combined-Shape"
        fill="#0088CE"
        fill-rule="nonzero"
      />
      <path
        d="M10,4.30665594 L10,4 C10,2.8954305 10.8954305,2 12,2 C13.1045695,2 14,2.8954305 14,4 L14,4.30665594 C16.2031143,5.0065135 18,6.90429486 18,10 L18,16 L20,18 L20,19 L4,19 L4,18 L6,16 L6,10 C6,6.90429486 7.79688569,5.0065135 10,4.30665594 Z"
        id="Combined-Shape"
        fill="#5F5F5F"
      />
    </g>
  </svg>
);

export const PlaceholderIcon = props => (
  <SvgIcon width="21px" height="21px" viewBox="0 0 21 21" {...props}>
    <defs />
    <g
      id="[08]-SMB-Account---ATP-Logs"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="[08e3]-SMB-Customer---File-Released"
        transform="translate(-33.000000, -205.000000)"
        stroke="#5F5F5F"
      >
        <g id="left-nav/all" transform="translate(15.000000, 76.000000)">
          <g
            id="left-nav/settings/selected"
            transform="translate(0.000000, 122.388060)"
          >
            <g
              id="icons/placeholder"
              transform="translate(18.279793, 6.965174)"
            >
              <rect
                id="Rectangle"
                x="0.5"
                y="0.5"
                width="19.3108808"
                height="18.9004975"
              />
              <path
                d="M0.507772021,0.497512438 L19.8031088,19.4029851"
                id="Line"
              />
              <path
                d="M19.8031088,0.497512438 L0.507772021,19.4029851"
                id="Line"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const SortAZIcon = props => (
  <SvgIcon {...props} width="20px" height="20px" viewBox="0 0 20 20">
    <defs />
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icons/icn-sortAZ" strokeWidth="2" stroke="#5F5F5F">
        <polyline id="Path-3-Copy" points="6 11.9965975 10 8 14 11.9957178" />
      </g>
    </g>
  </SvgIcon>
);

export const SortZAIcon = props => (
  <SvgIcon
    {...props}
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
  >
    <defs />
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icons/icn-sortZA" strokeWidth="2" stroke="#5F5F5F">
        <polyline
          id="Path-3-Copy"
          transform="translate(10.000000, 9.998299) scale(1, -1) translate(-10.000000, -9.998299) "
          points="6 11.9965975 10 8 14 11.9957178"
        />
      </g>
    </g>
  </SvgIcon>
);

export const NoSortIcon = props => (
  <SvgIcon {...props} width="20px" height="20px" viewBox="0 0 20 20">
    <defs />
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icons/icn-notSorted" stroke="#AFAFAF" strokeWidth="2">
        <polyline
          id="Path-3-Copy"
          transform="translate(10.000000, 14.498299) scale(1, -1) translate(-10.000000, -14.498299) "
          points="7 15.9965975 10 13 13 15.9957178"
        />
        <polyline id="Path-3-Copy-2" points="7 6.99659746 10 4 13 6.99571776" />
      </g>
    </g>
  </SvgIcon>
);

export const GaugeIcon = props => (
  <SvgIcon {...props} width="20px" height="20px" viewBox="0 0 20 20">
    <defs />
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icons/icn-overview">
        <path
          d="M2,10.8277 C2,13.3577 3.159,15.6857 5.181,17.2137 C5.621,17.5467 5.708,18.1737 5.375,18.6147 C5.042,19.0547 4.415,19.1407 3.975,18.8087 C1.449,16.8997 0,13.9907 0,10.8277 C0,5.3137 4.486,0.8277 10,0.8277 C11.326,0.8277 12.589,1.0927 13.749,1.5627 C13.345,2.1017 12.927,2.6607 12.5,3.2337 C11.712,2.9737 10.874,2.8277 10,2.8277 C5.589,2.8277 2,6.4167 2,10.8277 Z M16.6587,6.4024 C16.9817,5.7074 17.3017,5.0184 17.6087,4.3544 C19.0967,6.1014 19.9997,8.3594 19.9997,10.8274 C19.9997,13.9904 18.5517,16.8994 16.0257,18.8094 C15.8457,18.9454 15.6337,19.0114 15.4237,19.0114 C15.1207,19.0114 14.8217,18.8744 14.6247,18.6144 C14.2917,18.1734 14.3797,17.5474 14.8197,17.2134 C16.8407,15.6854 17.9997,13.3584 17.9997,10.8274 C17.9997,9.1924 17.5047,7.6704 16.6587,6.4024 Z"
          id="Combined-Shape"
          fill="#5F5F5F"
        />
        <path
          d="M11.1406,13.398 C10.7236,14.097 9.8186,14.326 9.1196,13.909 C8.4196,13.491 8.1916,12.586 8.6086,11.887 C9.0256,11.188 17.4186,0 17.4186,0 C17.4186,0 11.5576,12.699 11.1406,13.398"
          id="Fill-1"
          fill="#0077C8"
        />
      </g>
    </g>
  </SvgIcon>
);

export const WindowIcon = props => (
  <SvgIcon {...props} width="20px" height="20px" viewBox="0 0 20 20">
    <defs />
    <g
      id="[09]-SMB-Account---Agent-Settings"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="[09a]-SMB-Customer---AGENTS"
        transform="translate(-857.000000, -383.000000)"
        fill="#5F5F5F"
      >
        <path
          d="M857,393.010006 L857,385.774318 L864.432444,384.74332 L864.432444,393.010006 L857,393.010006 Z M857,394.261849 L857,400.277328 L864.432444,401.289133 L864.432444,394.261849 L857,394.261849 Z M877,393.010006 L877,383 L865.689859,384.568896 L865.689859,393.010006 L877,393.010006 Z M877,394.261849 L877,403 L865.689859,401.46031 L865.689859,394.261849 L877,394.261849 Z"
          id="Combined-Shape"
        />
      </g>
    </g>
  </SvgIcon>
);

export const DownloadIcon = props => (
  <svg width="24px" height="24x" viewBox="0 0 24 24">
    <g
      id="icons/component/color/downloads"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M10,18 L12,20 L14,18 L22,18 L22,22 L2,22 L2,18 L10,18 Z"
        id="Combined-Shape"
        fill="#0088CE"
      />
      <polygon
        id="Combined-Shape"
        fill="#5F5F5F"
        points="14 11 14 2 10 2 10 11 5 11 12 18 19 11"
      />
    </g>
  </svg>
);

export const MailIcon = props => (
  <svg {...props} width="20px" height="16px" viewBox="0 0 20 16">
    <g
      id="[09]-SMB-Account---Agent-Settings"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="[09a]-SMB-Customer---AGENTS"
        transform="translate(-309.000000, -435.000000)"
        fill="#5F5F5F"
      >
        <g id="icons/email" transform="translate(309.000000, 433.000000)">
          <path
            d="M18,2 L2,2 C0.9,2 0,2.9 0,4 L0,16 C0,17.1 0.9,18 2,18 L18,18 C19.1,18 20,17.1 20,16 L20,4 C20,2.9 19.1,2 18,2 L18,2 Z M18,6 L10,11 L2,6 L2,4 L10,9 L18,4 L18,6 L18,6 Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const ClipboardIcon = ({ classes, color, ...others }) => (
  <SvgIcon {...others} viewBox="0 0 20 20">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icons/icn-download" fill={color || '#5F5F5F'}>
        <path
          d="M12.8,2 C12.4,0.8 11.3,0 10,0 C8.7,0 7.6,0.8 7.2,2 L4,2 C2.9,2 2,2.9 2,4 L2,18 C2,19.1 2.9,20 4,20 L16,20 C17.1,20 18,19.1 18,18 L18,4 C18,2.9 17.1,2 16,2 L12.8,2 Z M10,2 C10.6,2 11,2.4 11,3 C11,3.6 10.6,4 10,4 C9.4,4 9,3.6 9,3 C9,2.4 9.4,2 10,2 L10,2 Z M16,18 L4,18 L4,4 L6,4 L6,7 L14,7 L14,4 L16,4 L16,18 Z M8,15 L8,13 L6,13 L6,15 L8,15 Z M8,11 L8,9 L6,9 L6,11 L8,11 Z M14,15 L14,13 L9,13 L9,15 L14,15 Z M14,11 L14,9 L9,9 L9,11 L14,11 Z"
          id="icn-report"
        />
      </g>
    </g>
  </SvgIcon>
);

export const SelectAllIcon = props => (
  <SvgIcon viewBox="0 0 20 20">
    <title>icons/select-all</title>
    <defs />
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icons/select-all-white" fill={props.color || '#FFFFFF'}>
        <path
          d="M5.9,8.1 L4.5,9.5 L9,14 L19,4 L17.6,2.6 L9,11.2 L5.9,8.1 L5.9,8.1 Z M17,17 L3,17 L3,3 L13,3 L13,1 L3,1 C1.9,1 1,1.9 1,3 L1,17 C1,18.1 1.9,19 3,19 L17,19 C18.1,19 19,18.1 19,17 L19,9 L17,9 L17,17 L17,17 Z"
          id="Shape"
        />
      </g>
    </g>
  </SvgIcon>
);

export const FolderIcon = props => (
  <SvgIcon viewBox="0 0 20 16">
    <title>icons/folder</title>
    <defs />
    <g
      id="[24]-SMB-Account---ATP-Settings"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="[24a]-SMB-Customer---ATP-Settings"
        transform="translate(-402.000000, -1164.000000)"
        fill={props.color || '#FFFFFF'}
      >
        <g id="icons/folder" transform="translate(402.000000, 1162.000000)">
          <path
            d="M8,2 L2,2 C0.9,2 0,2.9 0,4 L0,16 C0,17.1 0.9,18 2,18 L18,18 C19.1,18 20,17.1 20,16 L20,6 C20,4.9 19.1,4 18,4 L10,4 L8,2 L8,2 Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const FileIcon = props => (
  <SvgIcon viewBox="0 0 16 20">
    <title>icons/file</title>
    <defs />
    <g
      id="[24]-SMB-Account---ATP-Settings"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="[24a]-SMB-Customer---ATP-Settings"
        transform="translate(-518.000000, -1162.000000)"
        fill={props.color || '#FFFFFF'}
      >
        <g id="icons/file" transform="translate(516.000000, 1162.000000)">
          <path
            d="M4,0 C2.9,0 2,0.9 2,2 L2,18 C2,19.1 2.9,20 4,20 L16,20 C17.1,20 18,19.1 18,18 L18,6 L12,0 L4,0 L4,0 Z M11,7 L11,1.5 L16.5,7 L11,7 L11,7 Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const UserIcon = props => (
  <SvgIcon {...props} color={props.color || '#000000'}>
    <path
      d="M20.4093402 19c-.6845169-2.1991941-5.0578489-4.0968632-6.3061214-4.2949674-.4163301-.066273-.4296085-1.2163387-.4296085-1.2163387s1.2356581-1.2164816 1.5056931-2.8549017c.7205478 0 1.1676155-1.73773123.4462602-2.35012637.0290868-.6438252.929933-5.05586477-3.6255636-5.05586477-4.55544282 0-3.65474008 4.41203956-3.62646078 5.05586477-.7204043.61239514-.27421586 2.35177027.4454348 2.35177027.27010674 1.6367762 1.50659018 2.8532578 1.50659018 2.8532578s-.0124708 1.1500657-.42880092 1.2163387C8.64843694 14.9031368 4.27517666 16.8008773 3.5906598 19 1.97701737 17.0935576 1 14.6363117 1 11.9536768 1 5.91375937 5.9345397 1 12 1s11 4.91375937 11 10.9536768C23 14.6363117 22.0230544 17.0935576 20.4093402 19M12 0C5.3725185 0 0 5.37253218 0 11.9999912 0 18.6273797 5.3725185 24 12 24c6.6273934 0 12-5.3726203 12-12.0000088C24 5.37253218 18.6273934 0 12 0"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const ExpandArrowIcon = props => (
  <SvgIcon {...props} color={props.color || '#000000'}>
    <path
      d="M9 2.55116038L8.44250143 2 4.5 5.89767923.55749857 2 0 2.55116038 4.5 7"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const SettingsIcon = ({ ...other }) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24">
    <g
      id="icons/component/color/Account-Settings"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="M22,12.527787 C21.4229041,12.0112722 20.7452396,11.6048158 20,11.3414114 L20,5 L4,5 L4,15 L12.3414114,15 C12.1203084,15.6255579 12,16.2987292 12,17 C12,17.7012708 12.1203084,18.3744421 12.3414114,19 L7,19 L7,18 C7.552,18 8,17.553 8,17 C8,16.447 7.552,16 7,16 L6,16 C5.448,16 5,16.447 5,17 C5,17.553 5.448,18 6,18 L6,19 L3,19 C2.448,19 2,18.553 2,18 L2,15 L2,4 C2,3.447 2.448,3 3,3 L21,3 C21.553,3 22,3.447 22,4 L22,12.527787 Z M13,13.6822049 C12.9310453,13.7859137 12.8652311,13.8918906 12.8026932,14 L5,14 L5,13 C5,11.65 7.65,11 9,11 C10.35,11 13,11.65 13,13 L13,13.6822049 Z M14,8 L14,6 L19,6 L19,8 L14,8 Z M14,11 L14,9 L19,9 L19,11 L14,11 Z M9,10 C7.9,10 7,9.1 7,8 C7,6.9 7.9,6 9,6 C10.1,6 11,6.9 11,8 C11,9.1 10.1,10 9,10 Z"
        id="Combined-Shape"
        fill="#5F5F5F"
      />
      <path
        d="M21.0535614,17.39 C21.0700061,17.262 21.0823395,17.132 21.0823395,17 C21.0823395,16.868 21.0700061,16.738 21.0535614,16.61 L21.923071,15.948 C22.001183,15.888 22.0237944,15.78 21.9724049,15.692 L21.1501736,14.306 C21.0987842,14.22 20.9918941,14.184 20.8993931,14.22 L19.8757151,14.622 C19.6639906,14.464 19.4317102,14.33 19.1809297,14.228 L19.0267613,13.168 C19.0082611,13.074 18.9239824,13 18.8212035,13 L17.1767409,13 C17.073962,13 16.9896833,13.074 16.9732387,13.168 L16.8190703,14.228 C16.5682898,14.33 16.3360094,14.462 16.1242849,14.622 L15.1006069,14.22 C15.0081059,14.186 14.9012158,14.22 14.8498264,14.306 L14.0275951,15.692 C13.9762056,15.778 13.998817,15.886 14.076929,15.948 L14.944383,16.61 C14.9279384,16.738 14.9156049,16.868 14.9156049,17 C14.9156049,17.132 14.9279384,17.262 14.944383,17.39 L14.076929,18.052 C13.998817,18.112 13.9762056,18.22 14.0275951,18.308 L14.8498264,19.694 C14.9012158,19.78 15.0081059,19.816 15.1006069,19.78 L16.1242849,19.378 C16.3360094,19.536 16.5682898,19.67 16.8190703,19.772 L16.9732387,20.832 C16.9896833,20.926 17.073962,21 17.1767409,21 L18.8212035,21 C18.9239824,21 19.0082611,20.926 19.0247057,20.832 L19.1788741,19.772 C19.4296546,19.67 19.661935,19.538 19.8736595,19.378 L20.8973375,19.78 C20.9898385,19.814 21.0967286,19.78 21.148118,19.694 L21.9703493,18.308 C22.0217388,18.222 21.9991274,18.114 21.9210154,18.052 L21.0535614,17.39 L21.0535614,17.39 Z M17.9989722,18.4 C17.2034634,18.4 16.5600675,17.774 16.5600675,17 C16.5600675,16.226 17.2034634,15.6 17.9989722,15.6 C18.794481,15.6 19.437877,16.226 19.437877,17 C19.437877,17.774 18.794481,18.4 17.9989722,18.4 Z"
        id="Shape"
        fill="#0088CE"
        fill-rule="nonzero"
      />
    </g>
  </svg>
);

export const CloudOnIcon = ({ color, ...other }) => (
  <SvgIcon
    {...other}
    color={color || '#5BA71B'}
    viewBox="0 0 20 20"
    width="20"
    height="20"
  >
    <path
      d="M16.1666667 8.25C15.5833333 5.275 13.0833333 3 10 3 7.58333333 3 5.5 4.4 4.5 6.5 1.91666667 6.85 0 9.0375 0 11.75 0 14.6375 2.25 17 5 17h10.8333333C18.1666667 17 20 15.075 20 12.625c0-2.275-1.75-4.2-3.8333333-4.375zm-2.9742263-2.11626732C12.3623282 5.28101128 11.2317366 4.75 10 4.75c-2.08333333 0-3.83333333 1.4875-4.41666667 3.5H5c-1.83333333 0-3.33333333 1.575-3.33333333 3.5s1.5 3.5 3.33333333 3.5h10.8333333c1.4166667 0 2.5-1.1375 2.5-2.625 0-1.0382497-.5277786-1.9059864-1.3283032-2.3354256l1.3324638-1.13668133s-.8326416-.77252198-2.1704102-.9093628c-.276184-1.8121338-1.6378173-3.2477417-1.6378173-3.2477417l-1.336826 1.1379441z"
      fillRule="evenodd"
    />
    <path d="M7.35172414 8.8245614L6 10.0526316 10.3448276 14 20 5.22807018 18.6482759 4l-8.3034483 7.5438596" />
  </SvgIcon>
);

export const CloudOffIcon = ({ color, ...other }) => (
  <SvgIcon
    {...other}
    color={color || '#BBB'}
    viewBox="0 0 20 20"
    width="20"
    height="20"
  >
    <path
      d="M16.1666667 8C15.5833333 5.16666667 13.0833333 3 10 3c-1.25 0-2.41666667.33333333-3.33333333 1l1.25 1.25C8.5 4.83333333 9.25 4.66666667 10 4.66666667c2.5 0 4.5833333 2.08333333 4.5833333 4.58333333v.41666667h1.25c1.4166667 0 2.5 1.08333333 2.5 2.50000003 0 .9166666-.5 1.75-1.3333333 2.1666666l1.25 1.25c1.0833333-.75 1.75-2 1.75-3.4166666C20 10 18.25 8.16666667 16.1666667 8zM2.5 4.08333333l2.33333333 2.25C2.16666667 6.5 0 8.66666667 0 11.3333333c0 2.75 2.25 5 5 5h9.75L16.4166667 18 17.5 16.9166667 3.58333333 3 2.5 4.08333333zM6.41666667 8l6.66666663 6.6666667H5c-1.83333333 0-3.33333333-1.5-3.33333333-3.3333334C1.66666667 9.5 3.16666667 8 5 8h1.41666667z"
      fill="#BBB"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const StatusPendingIcon = ({ color, ...other }) => (
  <SvgIcon
    {...other}
    color={color || '#0088CF'}
    viewBox="0 0 20 20"
    width="20"
    height="20"
  >
    <path
      d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm.5-13H9v6l5.2 3.2.8-1.3-4.5-2.7V5z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const SearchIcon = ({ color, ...other }) => (
  <SvgIcon {...other} viewBox="0 0 18 18" width="100%" height="100%">
    <path
      d="M11.4285714,10.0571429 L10.6971429,10.0571429 L10.4228571,9.78285714 C11.3371429,8.77714286 11.8857143,7.40571429 11.8857143,5.94285714 C11.8857143,2.65142857 9.23428571,0 5.94285714,0 C2.65142857,0 0,2.65142857 0,5.94285714 C0,9.23428571 2.65142857,11.8857143 5.94285714,11.8857143 C7.40571429,11.8857143 8.77714286,11.3371429 9.78285714,10.4228571 L10.0571429,10.6971429 L10.0571429,11.4285714 L14.6285714,16 L16,14.6285714 L11.4285714,10.0571429 L11.4285714,10.0571429 Z M5.94285714,10.0571429 C3.65714286,10.0571429 1.82857143,8.22857143 1.82857143,5.94285714 C1.82857143,3.65714286 3.65714286,1.82857143 5.94285714,1.82857143 C8.22857143,1.82857143 10.0571429,3.65714286 10.0571429,5.94285714 C10.0571429,8.22857143 8.22857143,10.0571429 5.94285714,10.0571429 L5.94285714,10.0571429 Z"
      fill={color || '#555555'}
    />
  </SvgIcon>
);

const closeIconStyleSheet = {
  closeIcon: {
    cursor: 'pointer',
  },
};
const CloseIconComponent = ({ classes, color, ...other }) => (
  <SvgIcon className={classes.closeIcon} {...other} viewBox="0 0 20 20">
    <path
      d="M18.76 0L10 8.76 1.24 0 0 1.24 8.76 10 0 18.76 1.24 20 10 11.24 18.76 20 20 18.76 11.24 10 20 1.24"
      fill={color || '#ffffff'}
      fillRule="evenodd"
    />{' '}
  </SvgIcon>
);
export const CloseIcon = withStyles(closeIconStyleSheet, {
  name: 'closeIconStyleSheet',
})(CloseIconComponent);

export const AddIcon = ({ color, ...props }) => (
  <SvgIcon viewBox="0 0 14 14" {...props}>
    <path fill={color || '#FFF'} d="M14 8H8v6H6V8H0V6h6V0h2v6h6" />
    <path d="M-3-3h20v20H-3z" fill="none" fillRule="evenodd" />
  </SvgIcon>
);

export const SubtractIcon = ({ color, ...props }) => (
  <SvgIcon viewBox="0 0 14 2" {...props}>
    <path d="M0 2V0h14v2" fill={color || '#FFF'} fillRule="evenodd" />
  </SvgIcon>
);

export const CheckmarkIcon = ({ color, ...props }) => (
  <SvgIcon viewBox="0 0 18 14" {...props}>
    <path
      fill={color || '#5F5F5F'}
      d="M5.6 10.6L1.4 6.4 0 7.8l5.6 5.6 12-12L16.2 0z"
    />
  </SvgIcon>
);

const dashboardIconLargeStyleSheet = {
  large: {
    width: 80,
    height: 80,
    padding: 25,
  },
  small: {
    width: 20,
    height: 20,
  },
};

const CheckCircleIconComponent = ({
  classes,
  color,
  disabled,
  large,
  ...other
}) => (
  <SvgIcon
    className={large ? classes.large : classes.small}
    viewBox="0 0 20 20"
  >
    <path
      fill={color || '#5F5F5F'}
      d="m10,0c-5.52,0 -10,4.48 -10,10s4.48,10 10,10s10,-4.48 10,-10s-4.48,-10 -10,-10zm-2,15l-5,-5l1.41,-1.41l3.59,3.58l7.59,-7.59l1.41,1.42l-9,9z"
    />
  </SvgIcon>
);
export const CheckCircleIcon = withStyles(dashboardIconLargeStyleSheet, {
  name: 'dashboardIconLargeStyleSheet',
})(CheckCircleIconComponent);

const menuArrowStyles = {
  small: {
    width: 24,
    height: 24,
  },
};
const _MenuArrowIcon = ({ classes, color, large, ...other }) => (
  <SvgIcon className={classes.small} viewBox="0 0 24 24">
    <path fill={color || '#000000'} d="M7,10L12,15L17,10H7Z" />
  </SvgIcon>
);
export const MenuArrowIcon = withStyles(menuArrowStyles, {
  name: 'menuArrowStyles',
})(_MenuArrowIcon);

const criticalIconStyleSheet = {
  large: {
    width: 20,
  },
  small: {
    width: 19,
  },
};
const CriticalIconComponent = ({ classes, color, large, ...other }) => (
  <SvgIcon
    className={large ? classes.large : classes.small}
    viewBox="0 0 20 20"
    fill="none"
    fillRule="evenodd"
  >
    <path
      d="M10,0 C15.52992,0 20,4.46992 20,10 C20,15.52992 15.52992,20 10,20 C4.46992,20 0,15.52992 0,10 C0,4.46992 4.46992,0 10,0 Z M9,13 L11,13 L11,3 L9,3 L9,13 Z M9,17 L11,17 L11,15 L9,15 L9,17 Z"
      fill={color || '#DD1E31'}
    />
  </SvgIcon>
);
export const CriticalIcon = withStyles(criticalIconStyleSheet, {
  name: 'criticalIconStyleSheet',
})(CriticalIconComponent);

const successIconStyleSheet = {
  large: {
    width: 24,
  },
  small: {
    width: 16,
  },
};

const SuccessIconComponent = ({
  classes,
  color,
  disabled,
  large,
  ...other
}) => (
  <SvgIcon
    className={large ? classes.large : classes.small}
    viewBox="0 0 16 16"
    fill="#5BA71B"
    fillRule="evenodd"
  >
    <path
      d="M6.260096,12.358912 L2.718336,8.817152 L3.842048,7.701504 L6.260096,10.11968 L12.402304,3.98336 L13.518976,5.099904 L6.260096,12.358912 Z M8,0 C3.575936,0 0,3.576064 0,8 C0,12.424064 3.575936,16 8,16 C12.423936,16 16,12.424064 16,8 C16,3.576064 12.423936,0 8,0 L8,0 Z"
      fill={color || '#5BA71B'}
      fillOpacity={disabled ? '.5' : '1'}
    />
  </SvgIcon>
);
export const SuccessIcon = withStyles(successIconStyleSheet, {
  name: 'successIconStyleSheet',
})(SuccessIconComponent);

const warningIconStyleSheet = {
  large: {
    width: 20,
  },
  small: {
    width: 16,
  },
};

const WarningIconComponent = ({ classes, large, color, ...props }) => {
  return (
    <SvgIcon
      className={large ? classes.large : classes.small}
      viewBox="0 0 16 16"
    >
      <path
        d="M8 .8L0 15.2h16L8 .8zm-.8 9.6h1.6V5.6H7.2v4.8zm0 3.2h1.6V12H7.2v1.6z"
        fill={color || '#F18E00'}
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};
export const WarningIcon = withStyles(warningIconStyleSheet, {
  name: 'warningIconStyleSheet',
})(WarningIconComponent);

const HelpIconComponent = ({ classes, color, ...other }) => {
  return (
    <SvgIcon
      {...other}
      viewBox="0 0 20 20"
      width="100%"
      height="100%"
      className={classes.helpIcon}
    >
      <path
        d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0z"
        className={classes.ring}
      />
      <path
        d="M10 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
        className={classes.fill}
      />
      <path
        className={classes.mark}
        d="M11 16H9v-2h2zM13.1 9.67l-.9.81c-.8.63-1.2 1.17-1.2 2.52H9v-.45c0-.99.4-1.89 1.2-2.52l1.2-1.17c.4-.27.6-.72.6-1.26 0-.99-.9-1.8-2-1.8s-2 .81-2 1.8H6C6 5.62 7.8 4 10 4s4 1.62 4 3.6c0 .81-.4 1.53-.9 2.07z"
      />
    </SvgIcon>
  );
};
const helpIconStyleSheet = {
  helpIcon: {
    height: '16px',
    width: '16px',
  },
  ring: {
    fill: '#0088CF',
  },
  fill: {
    fill: '#FFF',
  },
  mark: {
    fill: '#0088CF',
  },
};
export const HelpIcon = withStyles(helpIconStyleSheet, {
  name: 'helpIconStyleSheet',
})(HelpIconComponent);

export const _InfoIcon = ({
  classes,
  color,
  disabled = false,
  hoverEnabled = true,
  ...props
}) => (
  <SvgIcon
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    className={hoverEnabled ? classes.infoIcon : classes.infoIconWithoutHover}
  >
    <path
      className={classes.hollow}
      d="M10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10 4.48 0 10 0zm0 2c-4.4154305 0-8 3.5845695-8 8 0 4.4154305 3.5845695 8 8 8 4.4154305 0 8-3.5845695 8-8 0-4.4154305-3.5845695-8-8-8zM9 6V4h2v2H9zm0 10V8h2v8H9z"
      fill={color || '#888'}
    />
    <path
      className={classes.full}
      d="M10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10 4.48 0 10 0zM8.75 6.25h2.5v-2.5h-2.5v2.5zm0 10h2.5v-7.5h-2.5v7.5z"
      fill={color || '#888'}
      fillRule="evenodd"
      fillOpacity={disabled ? '.5' : '1'}
    />
  </SvgIcon>
);

const InfoIconStyleSheet = {
  infoIcon: {
    width: '16px',
    height: '16px',
    '&:hover $full': {
      display: 'block',
    },
    '&:hover $hollow': {
      display: 'none',
    },
  },
  full: {
    display: 'none',
  },
  hollow: {},
  infoIconWithoutHover: {
    width: '16px',
    height: '16px',
    '& $full': {
      display: 'block',
    },
    '& $hollow': {
      display: 'none',
    },
  },
};
export const InfoIcon = withStyles(InfoIconStyleSheet, {
  name: 'InfoIconStyleSheet',
})(_InfoIcon);

export const StepNumber = ({
  circleColor,
  numberColor,
  children,
  active = true,
  ...other
}) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <circle
        fill={circleColor || '#FFF'}
        cx="12"
        cy="12"
        r="12"
        fillOpacity={active ? 1 : 0.4}
      />
      <text
        fontFamily="Roboto-Medium, Roboto"
        fontSize="12"
        fontWeight="400"
        fill="#0088CF"
      >
        <tspan
          fill={numberColor || '#0088CF'}
          x="9.09"
          y="17"
          fontWeight={'bold'}
        >
          {children}
        </tspan>
      </text>
    </g>
  </SvgIcon>
);

export const StepNumberInactive = ({
  circleColor,
  numberColor,
  children,
  ...other
}) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" opacity=".4">
      <path d="M0 0h24v24H0z" />
      <circle stroke={circleColor || '#FFF'} cx="12" cy="12" r="11.5" />
      <text fontFamily="Roboto-Medium, Roboto" fontSize="12" fontWeight="400">
        <tspan fill={numberColor || '#fff'} x="9.09" y="17">
          {children}
        </tspan>
      </text>
    </g>
  </SvgIcon>
);

export const BackArrowIcon = ({ color, ...other }) => (
  <SvgIcon {...other} viewBox="0 0 16 16">
    <path
      fill={color || '#0088CF'}
      d="M3.8 7l5.6-5.6L8 0 0 8l8 8 1.4-1.4L3.8 9H16V7z"
    />
  </SvgIcon>
);

const paginationStyleSheet = {
  size: {
    width: 8,
    height: 13,
  },
};

const PaginationBackComponent = ({ classes, disabled = false, ...other }) => {
  return (
    <SvgIcon {...other} className={classes.size} viewBox="0 0 8 13">
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        fillOpacity="0.5"
      >
        <g
          id="[06a]-Blacklist"
          transform="translate(-1158.000000, -896.000000)"
          fill={disabled ? '#aaaaaa' : '#000000'}
        >
          <polygon
            id="Shape"
            points="1165.4 907.1 1160.8 902.5 1165.4 897.9 1164 896.5 1158 902.5 1164 908.5"
          />
        </g>
      </g>
    </SvgIcon>
  );
};
export const PaginationBack = withStyles(paginationStyleSheet, {
  name: 'paginationStyleSheet',
})(PaginationBackComponent);

const PaginationNextComponent = ({ classes, disabled = false, ...other }) => {
  return (
    <SvgIcon {...other} className={classes.size} viewBox="0 0 8 13">
      <g
        id="Application-Detail---Blacklist"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        fillOpacity="0.5"
      >
        <g
          id="[06a]-Blacklist"
          transform="translate(-1207.000000, -896.000000)"
          fill={disabled ? '#aaaaaa' : '#000000'}
        >
          <polygon
            id="Shape"
            points="1207.6 907.3 1212.2 902.8 1207.6 898.2 1209 896.8 1215 902.8 1209 908.8"
          />
        </g>
      </g>
    </SvgIcon>
  );
};
export const PaginationNext = withStyles(paginationStyleSheet, {
  name: 'paginationStyleSheet',
})(PaginationNextComponent);

export const AllowlistIcon = props => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M14 2.0005h-2c0-1.105-.895-2-2-2s-2 .895-2 2H6v3h8v-3z"
      fill="#0077C8"
    />
    <path
      d="M4 3v3h12V3h2c.5522847 0 1 .44771525 1 1v15c0 .5522847-.4477153 1-1 1H2c-.55228475 0-1-.4477153-1-1V4c0-.55228475.44771525-1 1-1h2zm5 12l-3-3-1 1 4 4 7-7-1-1-6 6z"
      fill="#5F5F5F"
    />
  </SvgIcon>
);

export const PieChartIcon = props => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M18 11c0 4.971-4.029 9-9 9s-9-4.029-9-9 4.029-9 9-9v9h9z"
      fill="#5F5F5F"
    />
    <path d="M20 9h-9V0c4.971 0 9 4.029 9 9" fill="#0077C8" />
  </SvgIcon>
);

export const BasicIcon = props => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M12.5 4.0005c0-.345.047-.677.121-1H0v2h12.621c-.074-.323-.121-.655-.121-1"
      fill="#5F5F5F"
    />
    <path
      d="M12.5 16.0005c0-.345.047-.677.121-1H0v2h12.621c-.074-.323-.121-.655-.121-1"
      fill="#5F5F5F"
    />
    <path
      d="M2.5 10.0005c0-.345.047-.677.121-1H0v2h2.621c-.074-.323-.121-.655-.121-1"
      fill="#5F5F5F"
    />
    <path
      d="M11.3789 9.0005c.074.323.121.655.121 1s-.047.677-.121 1h8.621v-2h-8.621z"
      fill="#5F5F5F"
    />
    <path
      d="M17 1.0005c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3"
      fill="#0077C8"
    />
    <path
      d="M7 7.0005c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3"
      fill="#0077C8"
    />
    <path
      d="M17 13.0005c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3"
      fill="#0077C8"
    />
  </SvgIcon>
);

export const BlockListIcon = props => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M14 2.0005h-2c0-1.105-.895-2-2-2s-2 .895-2 2H6v3h8v-3z"
      fill="#0077C8"
    />
    <path
      d="M4 3v3h12V3h2c.5522847 0 1 .44771525 1 1v15c0 .5522847-.4477153 1-1 1H2c-.55228475 0-1-.4477153-1-1V4c0-.55228475.44771525-1 1-1h2zm11 6l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4z"
      fill="#5F5F5F"
    />
  </SvgIcon>
);

export const BruteForceIcon = props => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M12.2467754 14.7577702C11.6928627 14.7587023 8.31313113 14.4198693 8 14c-.31313113-.4198693-.54007604-2.7021399 0-4 .19192785-.23300084 1.31768472.3248794 1.50112465.5399161.15695314.2322899 0 1.4988412.49887535 2.4600839.5045776-.0848999.6651001-.1046753 1 0-.5722128-1.7295356-.1591492-3.45913696 0-4-.979126.43011475-3.21577388.25535326-4 0-1.02031573 2.1487859-.74896496 5.3827314 0 6 .74896496.6172686 2.36186538.5998647 3.1527867.7862719.3555141.1104566.1433559 2.0923461-1.21450162 2.0923461-1.3578575 0-4.27775934-.7176677-4.71740802-1.0289677C3.72989884 16.5015349 1.80386526 14.9041494 1 13H0c0-2 .00231934-7 0-9h1c1.95196533 0 5.6716919.93884277 7.00892.98673396C8.99768926 5.02214552 12.1233215 5.72665406 13 6c.8766785.27334595.5728149 8.7587023-.7532246 8.7577702z"
      id="Fill-1"
      fill="#5F5F5F"
    />
    <path
      id="Fill-4"
      fill="#0077C8"
      d="M16.0860758 12.6280741L20 7.9165997l-4.2027371-1.83241866L17.636876 0l-4.2120055 3.1135273-.8508921-2.67422904-1.5678419 3.82603504.7507344.0739397.7184447-1.00760063.5103559 1.5265563 1.6751751-.56467428-.6727011 2.27217616 2.802921 2.0907254-2.3466802 3.14771864 1.0550942 3.2565616-2.4940765.5763622-.0609915 1.9518244-1.2379269-.4936967L11 17.3303635 13.871245 20l.0349805-3.0099428 4.2132014.2406484-1.2616882-2.8556338z"
    />
  </SvgIcon>
);

export const WebScrapingIcon = props => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M7 5h6c2.209139 0 4 1.790861 4 4v6H3V9c0-2.209139 1.790861-4 4-4zm10 4h2v4h-2V9zM1 9h2v4H1V9zm2 7h14c0 2.209139-1.790861 4-4 4H7c-2.209139 0-4-1.790861-4-4zm4-4c1.1045695 0 2-.8954305 2-2s-.8954305-2-2-2-2 .8954305-2 2 .8954305 2 2 2zm6 0c1.1045695 0 2-.8954305 2-2s-.8954305-2-2-2-2 .8954305-2 2 .8954305 2 2 2z"
      id="Combined-Shape"
      fill="#5F5F5F"
    />
    <path
      d="M11 3.7324356V5H9V3.7324356C8.40219863 3.3866262 8 2.74028237 8 2c0-1.1045695.8954305-2 2-2s2 .8954305 2 2c0 .74028236-.4021986 1.3866262-1 1.7324356z"
      id="Combined-Shape"
      fill="#0077C8"
    />
  </SvgIcon>
);

export const SlowClientIcon = props => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M14.6220009 1.1348528C9.72566245-1.41828564 3.68797014.4816528 1.13483168 5.37799128c-2.5531077 4.89636923-.65316923 10.93406153 4.2432 13.48716923 4.89630772 2.5531385 10.93400002.6531692 13.48710772-4.2431692 2.5531384-4.8963385.6532-10.93400003-4.2431385-13.4871385m-1.156 2.21627693c3.6681231 1.91166154 5.0935692 6.45067693 3.1828616 10.11584617-1.9107077 3.6651692-6.4477231 5.0935692-10.1148616 3.1819077-3.6680923-1.9116923-5.09353845-6.4506769-3.18286152-10.11587694C5.2618163 2.86783743 9.79886245 1.43848358 13.4660009 3.35112973"
      id="icn-duration-20-copy"
      fill="#5F5F5F"
    />
    <path
      d="M15.8334462 9.77993846c0 3.19163074-2.5902154 5.77993844-5.7799385 5.77993844-2.17233847 0-4.06449232-1.1989538-5.0535077-2.9710154l4.42867692-2.80892304V4c3.74910768 0 6.40476928 2.58827692 6.40476928 5.77993846"
      id="Fill-4-Copy"
      fill="#0077C8"
    />
  </SvgIcon>
);

export const ClientEvaluationIcon = props => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M2 0h16c1.1045695 0 2 .8954305 2 2v16c0 1.1045695-.8954305 2-2 2H2c-1.1045695 0-2-.8954305-2-2V2C0 .8954305.8954305 0 2 0zM1 4v12h18V4H1z"
      id="Combined-Shape"
      fill="#5F5F5F"
    />
    <path
      d="M3.52539088 14h1.2729492L3.7885745 8.18847656H2.51562524L3.52539088 14zm.0805664-7.2993164c0-.1969411-.06445248-.36523368-.19335937-.50488282-.1289069-.13964913-.30257052-.21305335-.5209961-.22021484-.20768332-.0071615-.38045177.0563958-.51831053.19067383-.13785877.134278-.2067871.29809473-.2067871.49145507 0 .2041026.067138.37239517.201416.50488282.13427802.13248764.30525612.20231116.51293945.20947265.2041026.0071615.37597587-.05460545.515625-.18530272.13964914-.13069727.20947266-.29272364.20947266-.486084z"
      id="i"
      fill="#0077C8"
    />
    <path
      d="M9.53955078 14c-.04296896-.1432299-.06087243-.3240549-.05371094-.5424805-.4798201.4475934-.9972303.6642254-1.5522461.6499024-.50488533-.0071615-.92293128-.1691879-1.25415038-.486084s-.4860841-.718829-.4645996-1.2058106c.02864597-.6123077.29361728-1.093911.79492186-1.4448242.5013046-.3509132 1.17447495-.5263672 2.01953126-.5263672l.82714843.0107422.07519532-.3974609c.0214845-.13964915.0214845-.27034446 0-.39208986-.07161494-.38672068-.3276345-.58544916-.7680664-.5961914-.27213678-.0071615-.51114806.06176685-.71704102.2067871-.20589295.14502026-.3321124.33927288-.3786621.58276368l-1.27294922.0107422c.02506522-.35807472.15217984-.67228056.38134765-.94262697.2291678-.2703464.53352675-.48071214.91308594-.6311035.3795592-.1503914.78059684-.22200526 1.203125-.21484376.63379223.01432298 1.12792793.2049949 1.48242183.57202147.354494.36702658.5013024.84236362.4404297 1.42602543l-.4458008 2.7231445-.0429687.4833984c-.0107422.2112641.016113.417154.0805664.6176758L10.8017578 14H9.53955078zm-1.31054687-.9345703c.26855604.0071615.51741423-.0546055.74658204-.1853027.2291678-.1306973.4243156-.2998851.58544922-.5075684l.19873046-1.1010742-.6069336-.0053711c-.4798201 0-.8629543.0904125-1.14941405.2712402-.28645977.1808277-.4493813.4287908-.48876953.7438965-.02864598.2399101.02416925.4287916.15844726.5666504.13427802.1378588.3195789.2103678.5559082.2175293z"
      id="a"
      fill="#0077C8"
    />
    <path
      d="M12.3876564 8.19921875c.0644534.7770221.5227822 1.3785786 1.375 1.80468745-.3186865.2041026-.5559074.4637029-.7116699.7788086-.1557625.3151058-.2193199.662433-.1906739 1.0419922.0465497.6875035.3276342 1.2434061.8432617 1.6677246.5156276.4243186 1.1547814.6293133 1.9174805.6149903.6946649-.014323 1.2469869-.2211081 1.6569824-.6203614.4099956-.3992533.5917158-.9229297.545166-1.5710449-.0644534-.8701215-.5854443-1.5289691-1.5629882-1.97656248.268556-.19336034.4672845-.43416197.5961914-.7224121.1289069-.28825014.1826173-.59708495.1611328-.92651368-.0501305-.67318045-.3151018-1.21476032-.7949219-1.62475586-.4798201-.40999554-1.0760055-.60782884-1.7885742-.59350586-.4261089.01074225-.8011865.10563062-1.1252441.28466797-.3240577.17903735-.5666496.42968588-.7277833.75195312-.1611336.32226724-.225586.6857076-.1933593 1.09033203zm1.7294922 3.56103515c-.0393883-.3616554.0304353-.6597482.2094726-.8942871.1790374-.2345389.4368473-.3553873.7734375-.3625488.3795592-.0071615.703612.1172676.972168.373291s.4243162.579181.4672851.9694824c.0393883.368817-.0322256.663329-.2148437.8835449-.1826181.220216-.440428.333903-.7734375.3410645-.3867207.0071615-.7116686-.1127918-.9748535-.3598633-.2631849-.2470715-.4162596-.5639629-.4592285-.9506836zm-.4511719-3.5180664c-.0322267-.32226724.0277499-.5890289.1799316-.80029297.1521818-.21126408.3768703-.32047522.6740723-.32763672.325848-.00716148.6042469.10384.8352051.33300782.2309582.22916782.3661293.52636537.4055175.89160157.0322268.3365902-.028645.60693256-.1826171.81103514-.1539722.2041026-.3759751.30973304-.6660157.31689454-.3294287.0071615-.6096179-.10563035-.8405761-.3383789-.2309582-.23274857-.3661294-.52815577-.4055176-.88623048z"
      id="8"
      fill="#0077C8"
    />
  </SvgIcon>
);

const menuIconStyleSheet = {
  icon: {
    cursor: 'pointer',
    height: '40px',
    width: '40px',
    float: 'right',
    '&:hover $menuCircle': {
      display: 'block',
    },
  },
  menuCircle: {
    display: 'none',
  },
};

export const _MenuIcon = ({ classes, ...other }) => (
  <SvgIcon viewBox="0 0 40 40" className={classes.icon} {...other}>
    <circle
      fill="#F3F3F3"
      cx="20"
      cy="20"
      r="20"
      className={classes.menuCircle}
    />
    <path d="M20 16c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
  </SvgIcon>
);
export const MenuIcon = withStyles(menuIconStyleSheet, {
  name: 'menuIconStyleSheet',
})(_MenuIcon);

export const DeleteIcon = ({ color, ...other }) => (
  <SvgIcon {...other} viewBox="0 0 20 20">
    <path
      d="M4 17c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5H4v12zM17 2h-3.5l-1-1h-5l-1 1H3v2h14V2z"
      fill={color || '#5F5F5F'}
    />
  </SvgIcon>
);

export const EditIconComponent = ({ classes, color, small, ...other }) => (
  <SvgIcon className={classes.size} {...other} viewBox="0 0 20 20">
    <path
      d="M1 15.2V19h3.8l11-11.1L12 4.1 1 15.2zM18.7 5c.4-.4.4-1 0-1.4l-2.3-2.3c-.4-.4-1-.4-1.4 0l-1.8 1.8L17 6.9 18.7 5z"
      fill={color || '#5F5F5F'}
    />
  </SvgIcon>
);

const editIconStyleSheet = {
  size: {
    width: 12,
    height: 12,
  },
};

export const EditIcon = withStyles(editIconStyleSheet, {
  name: 'editIconStyleSheet',
})(EditIconComponent);

export const ReloadIconComponent = ({ classes, color, ...other }) => (
  <SvgIcon id="icon-loop2" viewBox="0 0 32 32" className={classes.size}>
    <g fill={color || '#ffffff'}>
      <path d="M27.802 5.197c-2.925-3.194-7.13-5.197-11.803-5.197-8.837 0-16 7.163-16 16h3c0-7.18 5.82-13 13-13 3.844 0 7.298 1.669 9.678 4.322l-4.678 4.678h11v-11l-4.198 4.197z" />
      <path d="M29 16c0 7.18-5.82 13-13 13-3.844 0-7.298-1.669-9.678-4.322l4.678-4.678h-11v11l4.197-4.197c2.925 3.194 7.13 5.197 11.803 5.197 8.837 0 16-7.163 16-16h-3z" />
    </g>
  </SvgIcon>
);

const reloadIconStyleSheet = {
  size: {
    width: 15,
    height: 15,
  },
};

export const ReloadIcon = withStyles(reloadIconStyleSheet, {
  name: 'reloadIconStyleSheet',
})(ReloadIconComponent);

const ArrowIconStyleSheet = {
  icon: {
    width: '40px',
    height: '40px',
    cursor: 'pointer',
    '&:hover $circle': {
      fill: '#ededed',
    },
  },
  iconDisabled: {
    extend: 'icon',
    cursor: 'default',
    fillOpacity: '0.3',
  },
  circle: {
    fill: 'transparent',
  },
};

export const _UpArrowIcon = ({ classes, color, disabled, ...other }) => {
  const fill = disabled ? '#000000' : color || '#0077C8';
  return (
    <SvgIcon
      {...other}
      viewBox="0 0 40 40"
      className={disabled ? classes.iconDisabled : classes.icon}
    >
      <circle id="ripple" cx="20" cy="20" r="20" className={classes.circle} />
      <path fill={fill} d="M15.4 24.4l4.6-4.6 4.6 4.6L26 23l-6-6-6 6z" />
    </SvgIcon>
  );
};

export const UpArrowIcon = withStyles(ArrowIconStyleSheet, {
  name: 'ArrowIconStyleSheet',
})(_UpArrowIcon);

export const _DownArrowIcon = ({ classes, color, disabled, ...other }) => {
  const fill = disabled ? '#000000' : color || '#0077C8';
  return (
    <SvgIcon
      {...other}
      viewBox="0 0 40 40"
      className={disabled ? classes.iconDisabled : classes.icon}
    >
      <circle id="ripple" cx="20" cy="20" r="20" className={classes.circle} />
      <path fill={fill} d="M15.4 16.6l4.6 4.6 4.6-4.6L26 18l-6 6-6-6z" />
    </SvgIcon>
  );
};

export const DownArrowIcon = withStyles(ArrowIconStyleSheet, {
  name: 'ArrowIconStyleSheet',
})(_DownArrowIcon);

export const VerifyIcon = ({ color, ...other }) => (
  <SvgIcon {...other} viewBox="0 0 20 20">
    <path
      d="M6.5 4.5L11 0v3.1c3.9.5 7 3.8 7 7.9 0 4.1-3.1 7.4-7 7.9v-2c2.8-.5 5-2.9 5-5.9 0-3-2.2-5.4-5-5.9V9L6.5 4.5zM2.1 10c.2-1.4.7-2.7 1.6-3.9l1.4 1.4c-.5.8-.9 1.6-1 2.5h-2zM9 16.9v2c-1.4-.2-2.7-.7-3.9-1.6l1.4-1.4c.8.5 1.6.9 2.5 1zm-3.9-2.4l-1.4 1.4c-.9-1.2-1.5-2.5-1.6-3.9h2c.1.9.5 1.7 1 2.5z"
      fill="#0077C8"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const SensitivityVeryLowIcon = ({ color, ...other }) => (
  <SvgIcon {...other} viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        d="M18 12l-8 8-8-8 1.4-1.4L9 16.2V6h2v10.2l5.6-5.6L18 12zM9 4V0h2v4H9z"
        fill={color || '#5F5F5F'}
      />
    </g>
  </SvgIcon>
);

export const SensitivityLowIcon = ({ color, ...other }) => (
  <SvgIcon {...other} viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        d="M18 10l-1.4-1.4-5.6 5.6V2H9v12.2L3.4 8.6 2 10l8 8"
        fill={color || '#5F5F5F'}
      />
    </g>
  </SvgIcon>
);

export const SensitivityNormalIcon = ({ color, ...other }) => (
  <SvgIcon {...other} viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        d="M7.17 9H0v2h7.17c.413 1.165 1.524 2 2.83 2s2.417-.835 2.83-2H20V9h-7.17c-.413-1.165-1.524-2-2.83-2s-2.417.835-2.83 2z"
        fill={color || '#5F5F5F'}
      />
    </g>
  </SvgIcon>
);

export const SensitivityHighIcon = ({ color, ...other }) => (
  <SvgIcon {...other} viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        d="M18 10l-1.4 1.4L11 5.8V18H9V5.8l-5.6 5.6L2 10l8-8"
        fill={color || '#5F5F5F'}
      />
    </g>
  </SvgIcon>
);

export const SensitivityVeryHighIcon = ({ color, ...other }) => (
  <SvgIcon {...other} viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        d="M18 8l-1.4 1.4L11 3.8V14H9V3.8L3.4 9.4 2 8l8-8 8 8zm-9 8h2v4H9v-4z"
        fill={color || '#5F5F5F'}
      />
    </g>
  </SvgIcon>
);

export const PeaceModeIcon = ({ color, ...other }) => (
  <SvgIcon {...other} viewBox="0 0 20 20">
    <path
      d="M10 17.928c1.725-.525 3.275-1.607 4.392-3.117C15.53 13.274 16 11.514 16 9.107v-3.87l-6-3c-.002 1.09-.002 6.322 0 15.692zM2 4l8-4 8 4v5.106c0 2.51-.458 4.81-2 6.894-1.542 2.085-3.708 3.447-6 4-2.292-.553-4.458-1.915-6-4-1.542-2.085-2-4.383-2-6.894V4z"
      fillRule="nonzero"
      fill="#FFF"
    />
  </SvgIcon>
);

export const PassiveModeIcon = ({ color, ...other }) => (
  <SvgIcon {...other} viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        d="M15.978 13.275l-1.54-.12-.273-1.52c-.19-1.046-.69-1.927-1.49-2.65C11.904 8.32 11.044 8 10 8c-.78 0-1.486.213-2.128.643-.71.477-1.256 1.085-1.64 1.832l-.498.97-1.085.107c-.722.07-1.316.388-1.83.974C2.257 13.2 2 13.893 2 14.76c0 .904.3 1.64.93 2.304.616.644 1.272.936 2.07.936h10.82c.576 0 1.072-.22 1.522-.69.453-.475.658-1 .658-1.69 0-.64-.2-1.165-.615-1.645-.39-.432-.85-.657-1.407-.7zM20 5.605V6.75h-5l1.857-1.857C14.692 2.97 12.47 2 10.217 2c-2.89 0-5.78 1.586-8.464 4.658-.363.416-.995.458-1.41.095-.417-.363-.46-.995-.096-1.41C3.28 1.868 6.687 0 10.217 0c2.818 0 5.518 1.194 8.057 3.476L20 1.75v3.855zm-3.867 5.676c1.055.083 1.992.533 2.734 1.352.742.86 1.133 1.842 1.133 2.988 0 1.187-.39 2.21-1.21 3.07-.82.86-1.837 1.31-2.97 1.31H5c-1.367 0-2.54-.532-3.516-1.556C.508 17.42 0 16.194 0 14.76c0-1.35.43-2.497 1.29-3.52.858-.983 1.913-1.556 3.163-1.68C5 8.498 5.78 7.638 6.758 6.983 7.734 6.327 8.828 6 10 6c1.523 0 2.852.49 3.984 1.474 1.133 1.023 1.875 2.292 2.15 3.807z"
        fill="#5F5F5F"
        fillRule="nonzero"
      />
    </g>
  </SvgIcon>
);
